/**
 * requirements2026.js
 * 2026학년도 수원대학교 전체 학과/전공 이수조건 데이터
 * 출처: 2026학년도 교육과정 (suwon_2026_all_curriculum_raw_and_parsed.json)
 * 생성일: 2026-05-09
 */

// ── 공통 교양 필수 과목 ───────────────────────────────────────────────────────
export const COMMON_LIBERAL_ARTS_2026 = [
  {
    courseCode: '11793',
    courseName: 'AI리터러시',
    category: 'coreLiberal',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11793',
    courseName: 'AI리터러시',
    category: 'coreLiberal',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 2,
    practiceHours: 1,
    source: 'liberal_arts',
  },
  {
    courseCode: '11794',
    courseName: 'AI시대의기업가정신-도전과창조',
    category: 'coreLiberal',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 2,
    practiceHours: 1,
    source: 'liberal_arts',
  },
  {
    courseCode: '11794',
    courseName: 'AI시대의기업가정신-도전과창조',
    category: 'coreLiberal',
    grade: 2,
    semester: 1,
    credits: 3,
    theoryHours: 2,
    practiceHours: 1,
    source: 'liberal_arts',
  },
  {
    courseCode: '09834',
    courseName: '한국어회화1',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09836',
    courseName: '기초한국어1',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11784',
    courseName: 'AI 세미나',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09835',
    courseName: '한국어회화2',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09837',
    courseName: '기초한국어2',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11785',
    courseName: '비즈니스영어',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11788',
    courseName: 'AI활용ESL1',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11790',
    courseName: 'AI활용CSL1',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11792',
    courseName: 'AI활용글쓰기',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11789',
    courseName: 'AI활용ESL2',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11791',
    courseName: 'AI활용CSL2',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11792',
    courseName: 'AI활용글쓰기',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10939',
    courseName: '인성과삶의가치',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11795',
    courseName: 'EDISON전공탐색',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 1,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10939',
    courseName: '인성과삶의가치',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11795',
    courseName: 'EDISON전공탐색',
    category: 'liberalArtsBasic',
    grade: 1,
    semester: 2,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11215',
    courseName: '인성과삶의가치(고운인성)',
    category: 'liberalArtsBasic',
    grade: 4,
    semester: 1,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11215',
    courseName: '인성과삶의가치(고운인성)',
    category: 'liberalArtsBasic',
    grade: 4,
    semester: 2,
    credits: 1,
    theoryHours: 1,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09133',
    courseName: '교양한국어초급',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09134',
    courseName: '교양한국어중급',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09778',
    courseName: '무의식과마음의대화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10035',
    courseName: '한국어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10110',
    courseName: '일본어Level1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10111',
    courseName: '일본어Level2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10116',
    courseName: '기초한국어이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10871',
    courseName: '교양프랑스어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10872',
    courseName: '여행프랑스어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10873',
    courseName: 'start 독일어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10874',
    courseName: 'easy 독일어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10875',
    courseName: 'start 러시아어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10876',
    courseName: 'easy 러시아어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11029',
    courseName: '글로벌교양1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11035',
    courseName: '글로벌리더십을위한외국어학습방법',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11208',
    courseName: 'ALL that English Basic',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11209',
    courseName: 'ALL that English1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11210',
    courseName: 'ALL that English Speaking1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11211',
    courseName: 'ALL that English2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11212',
    courseName: 'ALL that English3',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11213',
    courseName: 'ALL that English Speaking2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11330',
    courseName: '세계와통번역',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11339',
    courseName: '여행영어와세계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11377',
    courseName: '영상언어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11569',
    courseName: '관광통역중국어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11577',
    courseName: '문화간커뮤니케이션의이론과응용',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11609',
    courseName: '아시아문화의교류와소통',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11642',
    courseName: 'International Communication',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12717',
    courseName: '생활한자',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12720',
    courseName: '응용중국어커뮤니케이션',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12732',
    courseName: 'EDISON전공설계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12734',
    courseName: '영어의사소통과AI',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09133',
    courseName: '교양한국어초급',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09134',
    courseName: '교양한국어중급',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09778',
    courseName: '무의식과마음의대화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10035',
    courseName: '한국어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10110',
    courseName: '일본어Level1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10111',
    courseName: '일본어Level2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10116',
    courseName: '기초한국어이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10871',
    courseName: '교양프랑스어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10872',
    courseName: '여행프랑스어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10873',
    courseName: 'start 독일어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10874',
    courseName: 'easy 독일어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10875',
    courseName: 'start 러시아어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10876',
    courseName: 'easy 러시아어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11029',
    courseName: '글로벌교양1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11035',
    courseName: '글로벌리더십을위한외국어학습방법',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11208',
    courseName: 'ALL that English Basic',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11209',
    courseName: 'ALL that English1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11210',
    courseName: 'ALL that English Speaking1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11211',
    courseName: 'ALL that English2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11212',
    courseName: 'ALL that English3',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11213',
    courseName: 'ALL that English Speaking2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11330',
    courseName: '세계와통번역',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11339',
    courseName: '여행영어와세계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11377',
    courseName: '영상언어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11569',
    courseName: '관광통역중국어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11577',
    courseName: '문화간커뮤니케이션의이론과응용',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11609',
    courseName: '아시아문화의교류와소통',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11642',
    courseName: 'International Communication',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12717',
    courseName: '생활한자',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12720',
    courseName: '응용중국어커뮤니케이션',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12732',
    courseName: 'EDISON전공설계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12734',
    courseName: '영어의사소통과AI',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04739',
    courseName: '유럽통합의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04925',
    courseName: '인간과우주',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '05310',
    courseName: '자연과학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07614',
    courseName: '환경과학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07756',
    courseName: '현대사회와미국문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07757',
    courseName: '유럽의문화적전통',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07760',
    courseName: '종교와21세기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10144',
    courseName: '한중문화비교',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10150',
    courseName: '중앙아시아의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10882',
    courseName: '문화콘텐츠의이해와비평',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10887',
    courseName: '북유럽의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10890',
    courseName: '미디어와인간관계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10913',
    courseName: '신화와과학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11023',
    courseName: '과학문명사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11030',
    courseName: '글로벌교양2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11039',
    courseName: '대중문화로이해하는중국',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11066',
    courseName: '생활속의과학원리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11071',
    courseName: '세계의축제와여행',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11072',
    courseName: '세계차(tea)산업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11076',
    courseName: '시베리아횡단열차와도시',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11078',
    courseName: '식문화의형성과세계화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11104',
    courseName: '일본사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11110',
    courseName: '정보화사회와뉴미디어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11113',
    courseName: '중세영국과프랑스의문화교류사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11114',
    courseName: '지성인의자아혁신과리더쉽',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11149',
    courseName: '현대사회와감성사고력',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11163',
    courseName: '문화컨텐츠산업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11180',
    courseName: '창의적콘텐츠와명품브랜딩론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11221',
    courseName: '4차산업혁명과미래',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11253',
    courseName: '과학의재발견',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11304',
    courseName: '문화기술과디지털콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11323',
    courseName: '생명공학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11403',
    courseName: '음식문화로이해하는중국',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11498',
    courseName: '세계언어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11570',
    courseName: '고대문명과고고학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11571',
    courseName: '중국도시랜선여행',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11580',
    courseName: '지식재산개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11582',
    courseName: '과학발달의역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11618',
    courseName: '그린콘텐츠:숲,나무,가든',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11644',
    courseName: '바이오제약의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12716',
    courseName: '글로벌문화와디지털콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12719',
    courseName: '언락(Unlock)러시아중앙·극동:문화와역사디딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04739',
    courseName: '유럽통합의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04925',
    courseName: '인간과우주',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '05310',
    courseName: '자연과학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07614',
    courseName: '환경과학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07756',
    courseName: '현대사회와미국문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07757',
    courseName: '유럽의문화적전통',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07760',
    courseName: '종교와21세기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10144',
    courseName: '한중문화비교',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10150',
    courseName: '중앙아시아의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10882',
    courseName: '문화콘텐츠의이해와비평',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10887',
    courseName: '북유럽의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10890',
    courseName: '미디어와인간관계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10913',
    courseName: '신화와과학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11023',
    courseName: '과학문명사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11030',
    courseName: '글로벌교양2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11039',
    courseName: '대중문화로이해하는중국',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11066',
    courseName: '생활속의과학원리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11071',
    courseName: '세계의축제와여행',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11072',
    courseName: '세계차(tea)산업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11076',
    courseName: '시베리아횡단열차와도시',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11078',
    courseName: '식문화의형성과세계화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11104',
    courseName: '일본사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11110',
    courseName: '정보화사회와뉴미디어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11113',
    courseName: '중세영국과프랑스의문화교류사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11114',
    courseName: '지성인의자아혁신과리더쉽',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11149',
    courseName: '현대사회와감성사고력',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11163',
    courseName: '문화컨텐츠산업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11180',
    courseName: '창의적콘텐츠와명품브랜딩론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11221',
    courseName: '4차산업혁명과미래',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11253',
    courseName: '과학의재발견',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11304',
    courseName: '문화기술과디지털콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11323',
    courseName: '생명공학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11403',
    courseName: '음식문화로이해하는중국',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11498',
    courseName: '세계언어의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11570',
    courseName: '고대문명과고고학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11571',
    courseName: '중국도시랜선여행',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11580',
    courseName: '지식재산개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11582',
    courseName: '과학발달의역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11618',
    courseName: '그린콘텐츠:숲,나무,가든',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11644',
    courseName: '바이오제약의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12716',
    courseName: '글로벌문화와디지털콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12719',
    courseName: '언락(Unlock)러시아중앙·극동:문화와역사디딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '00506',
    courseName: '결혼과가족',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02066',
    courseName: '러시아명작의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02073',
    courseName: '러시아문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02816',
    courseName: '법과현대생활',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04165',
    courseName: '언어와문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07068',
    courseName: '한국경제의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07192',
    courseName: '한국정치의분석',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07393',
    courseName: '현대사회와매스컴',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07723',
    courseName: '프랑스문학과미술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07770',
    courseName: '한반도와국제정치',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07779',
    courseName: '성과사랑',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '08775',
    courseName: '박물관문화콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09779',
    courseName: '동아시아역사속의전쟁과평화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10023',
    courseName: '인간심리의분석',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10102',
    courseName: '한국사인물전',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10105',
    courseName: '20세기한국사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10126',
    courseName: '디아스포라문학과영화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10128',
    courseName: '명심보감의현대적이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10129',
    courseName: '문학과스토리텔링',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10130',
    courseName: '문예창작의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10136',
    courseName: '문화로보는서양의역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10142',
    courseName: '서양문학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10878',
    courseName: '문화와정치',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10888',
    courseName: '동유럽의사회와문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10889',
    courseName: '경제,경영과삶',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10901',
    courseName: '예술에나타난종교와철학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11024',
    courseName: '광고홍보의이해와실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11031',
    courseName: '글로벌교양3',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11036',
    courseName: '금융의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11046',
    courseName: '디지털사회의마케팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11052',
    courseName: '문학철학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11062',
    courseName: '산업사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11067',
    courseName: '설득커뮤니케이션',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11080',
    courseName: '신화와철학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11081',
    courseName: '신화의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11087',
    courseName: '여성과법률',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11109',
    courseName: '정보사회와경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11112',
    courseName: '조직속의심리학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11116',
    courseName: '창업마케팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11128',
    courseName: '한국행정의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11135',
    courseName: '현대중국사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11151',
    courseName: '스타트업아이디어와가치창출',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11165',
    courseName: '조직과리더십',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11166',
    courseName: '스타트업과비즈니스모델',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11181',
    courseName: '신문과사회트렌드분석론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11233',
    courseName: 'STARTUP BUSINESSPLAN',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11278',
    courseName: '동서문화교류사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11290',
    courseName: '러시아역사와사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11315',
    courseName: '발달주기와생애설계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11316',
    courseName: '법의사유적접근',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11317',
    courseName: '벤처스타트업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11318',
    courseName: '벤처창업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11324',
    courseName: '생활과금융',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11326',
    courseName: '생활속의경제경영론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11378',
    courseName: '영상역사학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11459',
    courseName: '한국사의재조명',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11467',
    courseName: '현대사회의창업과리더십',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11471',
    courseName: '화성의문화와역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11497',
    courseName: '아동심리의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11572',
    courseName: '한국의세계문화유산',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11573',
    courseName: '글로벌비즈니스에티켓&매너',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11575',
    courseName: '융합적사고의기초',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11576',
    courseName: '자기개발과청년창업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11608',
    courseName: '사회적책임과ESG경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11613',
    courseName: '기후변화와국제사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11615',
    courseName: '창의적문제해결',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11619',
    courseName: '로컬콘텐츠와창업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11643',
    courseName: '세계속의한국경제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12713',
    courseName: '글로벌여가트렌드와K콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12714',
    courseName: '디지털미디어로보는북한문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12715',
    courseName: 'AI시대의동서양신화읽기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12718',
    courseName: '동아시아도시의문화유산',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12722',
    courseName: '전쟁속삶의지혜와전략',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12723',
    courseName: '한국사회와언어문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12726',
    courseName: '지역유산브랜딩개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '00506',
    courseName: '결혼과가족',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02066',
    courseName: '러시아명작의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02073',
    courseName: '러시아문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '02816',
    courseName: '법과현대생활',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '04165',
    courseName: '언어와문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07068',
    courseName: '한국경제의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07192',
    courseName: '한국정치의분석',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07393',
    courseName: '현대사회와매스컴',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07723',
    courseName: '프랑스문학과미술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07770',
    courseName: '한반도와국제정치',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '07779',
    courseName: '성과사랑',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '08775',
    courseName: '박물관문화콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09779',
    courseName: '동아시아역사속의전쟁과평화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10023',
    courseName: '인간심리의분석',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10102',
    courseName: '한국사인물전',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10105',
    courseName: '20세기한국사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10126',
    courseName: '디아스포라문학과영화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10128',
    courseName: '명심보감의현대적이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10129',
    courseName: '문학과스토리텔링',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10130',
    courseName: '문예창작의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10136',
    courseName: '문화로보는서양의역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10142',
    courseName: '서양문학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10878',
    courseName: '문화와정치',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10888',
    courseName: '동유럽의사회와문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10889',
    courseName: '경제,경영과삶',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10901',
    courseName: '예술에나타난종교와철학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11024',
    courseName: '광고홍보의이해와실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11031',
    courseName: '글로벌교양3',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11036',
    courseName: '금융의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11046',
    courseName: '디지털사회의마케팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11052',
    courseName: '문학철학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11062',
    courseName: '산업사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11067',
    courseName: '설득커뮤니케이션',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11080',
    courseName: '신화와철학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11081',
    courseName: '신화의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11087',
    courseName: '여성과법률',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11109',
    courseName: '정보사회와경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11112',
    courseName: '조직속의심리학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11116',
    courseName: '창업마케팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11128',
    courseName: '한국행정의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11135',
    courseName: '현대중국사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11151',
    courseName: '스타트업아이디어와가치창출',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11165',
    courseName: '조직과리더십',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11166',
    courseName: '스타트업과비즈니스모델',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11181',
    courseName: '신문과사회트렌드분석론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11233',
    courseName: 'STARTUP BUSINESSPLAN',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11278',
    courseName: '동서문화교류사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11290',
    courseName: '러시아역사와사회의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11315',
    courseName: '발달주기와생애설계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11316',
    courseName: '법의사유적접근',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11317',
    courseName: '벤처스타트업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11318',
    courseName: '벤처창업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11324',
    courseName: '생활과금융',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11326',
    courseName: '생활속의경제경영론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11378',
    courseName: '영상역사학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11459',
    courseName: '한국사의재조명',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11467',
    courseName: '현대사회의창업과리더십',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11471',
    courseName: '화성의문화와역사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11497',
    courseName: '아동심리의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11572',
    courseName: '한국의세계문화유산',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11573',
    courseName: '글로벌비즈니스에티켓&매너',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11575',
    courseName: '융합적사고의기초',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11576',
    courseName: '자기개발과청년창업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11608',
    courseName: '사회적책임과ESG경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11613',
    courseName: '기후변화와국제사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11615',
    courseName: '창의적문제해결',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11619',
    courseName: '로컬콘텐츠와창업',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11643',
    courseName: '세계속의한국경제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12713',
    courseName: '글로벌여가트렌드와K콘텐츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12714',
    courseName: '디지털미디어로보는북한문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12715',
    courseName: 'AI시대의동서양신화읽기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12718',
    courseName: '동아시아도시의문화유산',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12722',
    courseName: '전쟁속삶의지혜와전략',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12723',
    courseName: '한국사회와언어문화',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12726',
    courseName: '지역유산브랜딩개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10906',
    courseName: '디지털리터러시',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10911',
    courseName: 'MOS1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11032',
    courseName: '글로벌교양4',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11045',
    courseName: '드론의활용과이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11084',
    courseName: '아이디어와발명',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11086',
    courseName: '엑셀과R을활용한응용통계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11103',
    courseName: '인공지능개념과원리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11107',
    courseName: '재난의과학적이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11121',
    courseName: '파이썬프로그래밍이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11154',
    courseName: '피지컬컴퓨팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11155',
    courseName: '컴퓨터적사고와코딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11159',
    courseName: '기술사업화이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11214',
    courseName: 'MOS2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11216',
    courseName: 'Google G-Suite활용과 이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11218',
    courseName: '클라우드컴퓨팅의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11228',
    courseName: 'JAVA프로그래밍입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11235',
    courseName: 'Startup웹프로그래밍',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11236',
    courseName: 'Startup인공지능코딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11238',
    courseName: 'VR애니메이션세계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11275',
    courseName: '데이터베이스언어SQL입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11293',
    courseName: '리눅스입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11614',
    courseName: '빅데이터시각화와탐색',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11616',
    courseName: '인공지능으로일하는기술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11640',
    courseName: '데이터베이스개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11641',
    courseName: '문제해결을위한컴퓨팅적사고',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12721',
    courseName: '과학기술의변천사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12727',
    courseName: '생성AI를활용한영상기획/제작/편집입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12728',
    courseName: '팔란티어의기초및활용',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '12731',
    courseName: '미래모빌리티',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10906',
    courseName: '디지털리터러시',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10911',
    courseName: 'MOS1',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11032',
    courseName: '글로벌교양4',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11045',
    courseName: '드론의활용과이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11084',
    courseName: '아이디어와발명',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11086',
    courseName: '엑셀과R을활용한응용통계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11103',
    courseName: '인공지능개념과원리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11107',
    courseName: '재난의과학적이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11121',
    courseName: '파이썬프로그래밍이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11154',
    courseName: '피지컬컴퓨팅',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11155',
    courseName: '컴퓨터적사고와코딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11159',
    courseName: '기술사업화이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11214',
    courseName: 'MOS2',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11216',
    courseName: 'Google G-Suite활용과 이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11218',
    courseName: '클라우드컴퓨팅의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11228',
    courseName: 'JAVA프로그래밍입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11235',
    courseName: 'Startup웹프로그래밍',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11236',
    courseName: 'Startup인공지능코딩',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11238',
    courseName: 'VR애니메이션세계',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11275',
    courseName: '데이터베이스언어SQL입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11293',
    courseName: '리눅스입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11614',
    courseName: '빅데이터시각화와탐색',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11616',
    courseName: '인공지능으로일하는기술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11640',
    courseName: '데이터베이스개론',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11641',
    courseName: '문제해결을위한컴퓨팅적사고',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12721',
    courseName: '과학기술의변천사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12727',
    courseName: '생성AI를활용한영상기획/제작/편집입문',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12728',
    courseName: '팔란티어의기초및활용',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '12731',
    courseName: '미래모빌리티',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10173',
    courseName: '발명과특허',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11033',
    courseName: '글로벌교양5',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11581',
    courseName: '4차산업혁명미래기술과Startup',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11610',
    courseName: '그린리더십의실무입문특강',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11611',
    courseName: '그린리더십산업의발견',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11612',
    courseName: '그린스타트업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11620',
    courseName: 'Startup처음배우는인공지능',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11621',
    courseName: '신제품개발과아이디어창출기법',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12724',
    courseName: '창업과협상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12725',
    courseName: '창업리더십과코칭',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12733',
    courseName: '4차산업혁명시대의품질경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10173',
    courseName: '발명과특허',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11033',
    courseName: '글로벌교양5',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11581',
    courseName: '4차산업혁명미래기술과Startup',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11610',
    courseName: '그린리더십의실무입문특강',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11611',
    courseName: '그린리더십산업의발견',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11612',
    courseName: '그린스타트업의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11620',
    courseName: 'Startup처음배우는인공지능',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11621',
    courseName: '신제품개발과아이디어창출기법',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12724',
    courseName: '창업과협상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12725',
    courseName: '창업리더십과코칭',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12733',
    courseName: '4차산업혁명시대의품질경영',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '05751',
    courseName: '전통예술의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10942',
    courseName: '창의프로젝트',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11017',
    courseName: '4차산업과스포츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11018',
    courseName: '4차산업혁명과음악',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11034',
    courseName: '글로벌교양6',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11038',
    courseName: '다이어트와체형관리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11051',
    courseName: '무대예술의이해와감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11058',
    courseName: '미디어아트와현대산업과사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11060',
    courseName: '미술로해석하는도시건축과자연환경',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11065',
    courseName: '생애주기건강관리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11068',
    courseName: '세계연극이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11069',
    courseName: '세계영화이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11079',
    courseName: '식생활과영양',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11082',
    courseName: '실용음악과공연예술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11090',
    courseName: '영화와여성이미지',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11095',
    courseName: '우리연극이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11099',
    courseName: '응급처치와안전',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11115',
    courseName: '지역사회와봉사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 2,
    theoryHours: 0,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11127',
    courseName: '한국영화로보는세상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11132',
    courseName: '현대생활과스포츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11160',
    courseName: '허브식물학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11161',
    courseName: '레저스포츠의이해와실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11289',
    courseName: '라켓스포츠의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11312',
    courseName: '미술과인문학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11325',
    courseName: '생활구기의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11438',
    courseName: '클래식음악과오페라',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11460',
    courseName: '한국음악의이해와감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11499',
    courseName: '일.사랑.행복',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11584',
    courseName: '세계명작의감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11617',
    courseName: '스포츠와심리학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11639',
    courseName: '생성형인공지능헬스케어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12729',
    courseName: '음악으로읽는20세기문화와사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12730',
    courseName: '캠퍼스합창',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 1,
    credits: 3,
    theoryHours: 0,
    practiceHours: 3,
    source: 'liberal_arts',
  },
  {
    courseCode: '05751',
    courseName: '전통예술의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '10942',
    courseName: '창의프로젝트',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11017',
    courseName: '4차산업과스포츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11018',
    courseName: '4차산업혁명과음악',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11034',
    courseName: '글로벌교양6',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11038',
    courseName: '다이어트와체형관리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11051',
    courseName: '무대예술의이해와감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11058',
    courseName: '미디어아트와현대산업과사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11060',
    courseName: '미술로해석하는도시건축과자연환경',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11065',
    courseName: '생애주기건강관리',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11068',
    courseName: '세계연극이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11069',
    courseName: '세계영화이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11079',
    courseName: '식생활과영양',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11082',
    courseName: '실용음악과공연예술',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11090',
    courseName: '영화와여성이미지',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11095',
    courseName: '우리연극이야기',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11099',
    courseName: '응급처치와안전',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11115',
    courseName: '지역사회와봉사',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 2,
    theoryHours: 0,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11127',
    courseName: '한국영화로보는세상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11132',
    courseName: '현대생활과스포츠',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11160',
    courseName: '허브식물학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11161',
    courseName: '레저스포츠의이해와실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11289',
    courseName: '라켓스포츠의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11312',
    courseName: '미술과인문학',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11325',
    courseName: '생활구기의이론과실제',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 1,
    practiceHours: 2,
    source: 'liberal_arts',
  },
  {
    courseCode: '11438',
    courseName: '클래식음악과오페라',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11460',
    courseName: '한국음악의이해와감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11499',
    courseName: '일.사랑.행복',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11584',
    courseName: '세계명작의감상',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11617',
    courseName: '스포츠와심리학의이해',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11639',
    courseName: '생성형인공지능헬스케어',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12729',
    courseName: '음악으로읽는20세기문화와사회',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 3,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '12730',
    courseName: '캠퍼스합창',
    category: 'liberalArtsElective',
    grade: 1,
    semester: 2,
    credits: 3,
    theoryHours: 0,
    practiceHours: 3,
    source: 'liberal_arts',
  },
  {
    courseCode: '01055',
    courseName: '교육사회학',
    category: 'teaching',
    grade: 2,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01060',
    courseName: '교육심리학',
    category: 'teaching',
    grade: 2,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01069',
    courseName: '교육철학및교육사',
    category: 'teaching',
    grade: 2,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09147',
    courseName: '교육과정',
    category: 'teaching',
    grade: 2,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01055',
    courseName: '교육사회학',
    category: 'teaching',
    grade: 2,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01060',
    courseName: '교육심리학',
    category: 'teaching',
    grade: 2,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01069',
    courseName: '교육철학및교육사',
    category: 'teaching',
    grade: 2,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09147',
    courseName: '교육과정',
    category: 'teaching',
    grade: 2,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01077',
    courseName: '교육행정및교육경영',
    category: 'teaching',
    grade: 3,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09148',
    courseName: '교육평가',
    category: 'teaching',
    grade: 3,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11623',
    courseName: '디지털교육',
    category: 'teaching',
    grade: 3,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01077',
    courseName: '교육행정및교육경영',
    category: 'teaching',
    grade: 3,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09148',
    courseName: '교육평가',
    category: 'teaching',
    grade: 3,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09528',
    courseName: '특수교육학개론',
    category: 'teaching',
    grade: 3,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '01058',
    courseName: '교육실습',
    category: 'teaching',
    grade: 4,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09150',
    courseName: '교직실무',
    category: 'teaching',
    grade: 4,
    semester: 1,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09151',
    courseName: '교육봉사',
    category: 'teaching',
    grade: 4,
    semester: 1,
    credits: 2,
    theoryHours: 0,
    practiceHours: 4,
    source: 'liberal_arts',
  },
  {
    courseCode: '01058',
    courseName: '교육실습',
    category: 'teaching',
    grade: 4,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09150',
    courseName: '교직실무',
    category: 'teaching',
    grade: 4,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '09151',
    courseName: '교육봉사',
    category: 'teaching',
    grade: 4,
    semester: 2,
    credits: 2,
    theoryHours: 0,
    practiceHours: 4,
    source: 'liberal_arts',
  },
  {
    courseCode: '10932',
    courseName: '학교폭력예방및학생의이해',
    category: 'teaching',
    grade: 4,
    semester: 2,
    credits: 2,
    theoryHours: 2,
    practiceHours: 0,
    source: 'liberal_arts',
  },
  {
    courseCode: '11162',
    courseName: '안보학',
    category: 'teaching',
    grade: 3,
    semester: 1,
    credits: 3,
    theoryHours: 0,
    practiceHours: 6,
    source: 'liberal_arts',
  },
  {
    courseCode: '11171',
    courseName: '안전및조직관리사례연구',
    category: 'teaching',
    grade: 3,
    semester: 2,
    credits: 3,
    theoryHours: 0,
    practiceHours: 6,
    source: 'liberal_arts',
  },
  {
    courseCode: '11172',
    courseName: '조직리더십',
    category: 'teaching',
    grade: 4,
    semester: 1,
    credits: 3,
    theoryHours: 0,
    practiceHours: 6,
    source: 'liberal_arts',
  },
  {
    courseCode: '11173',
    courseName: '조직리더십사례연구',
    category: 'teaching',
    grade: 4,
    semester: 2,
    credits: 3,
    theoryHours: 0,
    practiceHours: 6,
    source: 'liberal_arts',
  },
];

// ── 학과별 이수조건 ──────────────────────────────────────────────────────────
export const REQUIREMENTS_2026 = [
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'korean_lang',
    departmentName: '한국언어문화',
    icon: '📚',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11067',
        courseName: '설득커뮤니케이션',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11067',
        courseName: '설득커뮤니케이션',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11668',
        courseName: '광고언어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11661',
        courseName: '맞춤법과문해력',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11669',
        courseName: '생성형AI와한국어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11658',
        courseName: '시창작연습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04170',
        courseName: '언어학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11657',
        courseName: '웹미디어글쓰기',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11660',
        courseName: 'K드라마의구조',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11659',
        courseName: '고전과캐릭터',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09854',
        courseName: '언어와역사',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09852',
        courseName: '영상인문학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11670',
        courseName: '출판과편집',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07073',
        courseName: '한국고전문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11666',
        courseName: '화법의원리',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11663',
        courseName: 'K문화콘텐츠',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10129',
        courseName: '문학과스토리텔링',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '09853',
        courseName: '언어정보학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11546',
        courseName: '언어치료학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11662',
        courseName: '한국어문법론1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10256',
        courseName: '현대시감상론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11664',
        courseName: 'L2한국어교육',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08786',
        courseName: '공연과영상대본',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02450',
        courseName: '문학과비평',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11665',
        courseName: '인터렉티브스토리텔링',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11671',
        courseName: '한국어문법론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07207',
        courseName: '한국현대문학의이해',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11547',
        courseName: '언어와인지',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11667',
        courseName: '이야기OSMU',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'english_lang',
    departmentName: '영미언어문화',
    icon: '✍️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11763',
        courseName: '영어와영어권문화',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11763',
        courseName: '영어와영어권문화',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03386',
        courseName: '생활영어회화1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03758',
        courseName: '스크린영어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04317',
        courseName: '영국문학사',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07821',
        courseName: '영미문화탐구',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04490',
        courseName: '영어발음연습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10037',
        courseName: '외국문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '03387',
        courseName: '생활영어회화2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04167',
        courseName: '언어의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04491',
        courseName: '영어방송청취',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07818',
        courseName: '영어사들여다보기',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04561',
        courseName: '영작문연습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10038',
        courseName: '외국어연습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10258',
        courseName: 'Topic Discussion1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03608',
        courseName: '셰익스피어',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07824',
        courseName: '영어구문의이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04513',
        courseName: '영어음성음운연구',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10259',
        courseName: 'Topic Discussion2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08756',
        courseName: '영미극의이해',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07826',
        courseName: '영어구문연습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04518',
        courseName: '영어의미연구',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10262',
        courseName: 'Debate1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03844',
        courseName: '시사영어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04536',
        courseName: '영어학이해',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04538',
        courseName: '영어형태어휘연구',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08758',
        courseName: 'BusinessEnglish',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10263',
        courseName: 'Debate2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'japanese_lang',
    departmentName: '일본언어문화',
    icon: '🗾',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11750',
        courseName: '일본어와일본문화',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11750',
        courseName: '일본어와일본문화',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11674',
        courseName: '베이직일본어1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10037',
        courseName: '외국문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11742',
        courseName: '일본어듣기첫걸음1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06435',
        courseName: '초급일어회화1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11751',
        courseName: '미디어로배우는일본문화',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11738',
        courseName: '베이직일본어2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11744',
        courseName: '실생활일본어',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10275',
        courseName: '실용일본어작문1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04167',
        courseName: '언어의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11743',
        courseName: '일본어듣기첫걸음2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06437',
        courseName: '초급일어회화2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10276',
        courseName: '실용일본어작문2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05176',
        courseName: '일본문학의이해1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11747',
        courseName: '일본어청해인증대비',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11745',
        courseName: '중급일본어독해1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06146',
        courseName: '중급일어회화1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08569',
        courseName: '현대일본어문법',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11672',
        courseName: '세계의언어와일본어발음',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10038',
        courseName: '외국어연습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05177',
        courseName: '일본문학의이해2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11746',
        courseName: '중급일본어독해2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06148',
        courseName: '중급일어회화2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11748',
        courseName: '관광비즈니스일어회화',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12622',
        courseName: '일본경제와지역사회',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11673',
        courseName: '일본어학의이해',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12623',
        courseName: '기업문화와비즈니스일본어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09179',
        courseName: '일본의역사와문화',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'chinese_lang',
    departmentName: '중국언어문화',
    icon: '🐉',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11753',
        courseName: '차이나문화컨텐츠산책',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11753',
        courseName: '차이나문화컨텐츠산책',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07998',
        courseName: '기초중국어회화',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10037',
        courseName: '외국문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06072',
        courseName: '중국고전문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09885',
        courseName: '중국문화의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06438',
        courseName: '초급중국어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11755',
        courseName: 'AI활용중국어작문연습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09887',
        courseName: '스크린중국어와대중문화',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04167',
        courseName: '언어의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10038',
        courseName: '외국어연습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08001',
        courseName: '응용중국어',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09886',
        courseName: '중국지역문화특강',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06115',
        courseName: '중국현대문학의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08567',
        courseName: 'HSK듣기연습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09888',
        courseName: '중국고전과리더쉽',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06102',
        courseName: '중국어학개론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08003',
        courseName: '중급중국어',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00648',
        courseName: '고급중국어',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09890',
        courseName: '시사중국어발표와토론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09889',
        courseName: '중국시가와전통문화',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06096',
        courseName: '중국어문법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11757',
        courseName: 'AI와 중한번역실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04048',
        courseName: '실용중국어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09891',
        courseName: '중국고전소설과중국문화',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11756',
        courseName: '중화권지역의정치와 경제',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10273',
        courseName: '실무통상중국어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10272',
        courseName: '의료관광중국어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11758',
        courseName: '중화권기업탐방과현장실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08011',
        courseName: '현대중국영화와소설',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'russian_lang',
    departmentName: '러시아언어문화',
    icon: '🏔️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11761',
        courseName: '러시아어와문화',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11761',
        courseName: '러시아어와문화',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10973',
        courseName: '러시아문학과영상예술',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10974',
        courseName: '러시아어발음과쓰기',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09861',
        courseName: '러시아어의응용1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09900',
        courseName: '실용러시아어말하기1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11759',
        courseName: '러시아사',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09901',
        courseName: '러시아어의응용2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10975',
        courseName: '러시아어읽기와듣기',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09903',
        courseName: '실용러시아어말하기2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04167',
        courseName: '언어의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02093',
        courseName: '러시아어학의이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10983',
        courseName: '미디어러시아어',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10992',
        courseName: '스크린러시아어와대중문화',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09906',
        courseName: '실무러시아어말하기1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10037',
        courseName: '외국문학의이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09905',
        courseName: '중앙아시아지역문화',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11760',
        courseName: '러시아사회문화',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03100',
        courseName: '비즈니스러시아어',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09908',
        courseName: '실무러시아어말하기2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10038',
        courseName: '외국어연습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10951',
        courseName: 'FLEX와TORFL',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07948',
        courseName: '고급러시아어회화1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10269',
        courseName: '러시아미디어와언어생활',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10270',
        courseName: '의료관광러시아어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11762',
        courseName: 'FLEX와TORFL2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08141',
        courseName: '고급러시아어회화2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10976',
        courseName: '러시아언어특강',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'law',
    departmentName: '법학',
    icon: '⚖️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11764',
        courseName: '법과4차산업사회',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11764',
        courseName: '법과4차산업사회',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00551',
        courseName: '경제법',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09913',
        courseName: '물권법총론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11529',
        courseName: '법률영어1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09912',
        courseName: '상법총론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07425',
        courseName: '형법총론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09915',
        courseName: '물권법각론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02823',
        courseName: '법학개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02852',
        courseName: '보험법',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10228',
        courseName: '세계무역과법',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07322',
        courseName: '헌법',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07427',
        courseName: '형법총론2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09918',
        courseName: '어음수표법',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09593',
        courseName: '지적재산권법',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09916',
        courseName: '채권법총론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09589',
        courseName: '형법각론1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07703',
        courseName: '회사법',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02720',
        courseName: '민법총칙',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09594',
        courseName: '영미법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09919',
        courseName: '채권법각론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07285',
        courseName: '행정법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07436',
        courseName: '행정법1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09592',
        courseName: '형법각론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02469',
        courseName: '물권법',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02721',
        courseName: '민사소송법',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06506',
        courseName: '친족·상속법',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07289',
        courseName: '행정법2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07429',
        courseName: '형사소송법',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09920',
        courseName: '민사법의이해와사례',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11765',
        courseName: '채권법',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'public_admin',
    departmentName: '행정학',
    icon: '🏛️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07314',
        courseName: '행정학원론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07314',
        courseName: '행정학원론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10041',
        courseName: '정책학원론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05950',
        courseName: '조사방법론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06183',
        courseName: '지방자치론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07297',
        courseName: '행정사',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11466',
        courseName: '행정언어와논리',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07301',
        courseName: '행정조직론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11143',
        courseName: '경찰행정학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04943',
        courseName: '인사행정론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07206',
        courseName: '한국행정론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09922',
        courseName: '행정과경제분석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07285',
        courseName: '행정법',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11767',
        courseName: '디지털정부와AI',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11766',
        courseName: '빅데이터분석과통계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05383',
        courseName: '재무행정론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06189',
        courseName: '지역개발론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11012',
        courseName: '행정영어강독1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00785',
        courseName: '공기업론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05790',
        courseName: '정보체계론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11005',
        courseName: '정책분석평가',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07299',
        courseName: '행정사무관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11013',
        courseName: '행정영어강독2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10235',
        courseName: '협상론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07916',
        courseName: '사회복지정책',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05804',
        courseName: '정부혁신론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11006',
        courseName: '정치사회사상',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09188',
        courseName: '과학기술정책',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09184',
        courseName: '정부규제론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09972',
        courseName: '캡스톤디자인',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08048',
        courseName: '환경정책',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'media_comm',
    departmentName: '미디어커뮤니케이션',
    icon: '📢',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '04163',
        courseName: '언론학개론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '04163',
        courseName: '언론학개론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01751',
        courseName: '대중문화론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02058',
        courseName: '디지털커뮤니케이션',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09926',
        courseName: '디지털콘텐츠제작1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '08947',
        courseName: '문화콘텐츠의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10375',
        courseName: '미디어정책과법',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10036',
        courseName: '외국어와문화',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '00231',
        courseName: 'P.R론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00964',
        courseName: '광고론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09927',
        courseName: '디지털콘텐츠제작2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '09604',
        courseName: '방송론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03126',
        courseName: '사진영상론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03801',
        courseName: '스피치커뮤니케이션',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09928',
        courseName: '광고기획론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09923',
        courseName: '매스커뮤니케이션이론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10237',
        courseName: '모바일미디어론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09924',
        courseName: '미디어조사방법론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08948',
        courseName: '방송영상제작1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05822',
        courseName: '정치커뮤니케이션',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06483',
        courseName: '취재와보도',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00235',
        courseName: 'P.R제작',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '00969',
        courseName: '광고제작',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '02204',
        courseName: '매스컴과사회',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09087',
        courseName: '방송영상제작2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '09930',
        courseName: '방송편성기획론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09929',
        courseName: '위기커뮤니케이션',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08053',
        courseName: '조직커뮤니케이션',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09932',
        courseName: '미디어산업론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05773',
        courseName: '정보사회론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09162',
        courseName: '졸업작품',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09088',
        courseName: '글로벌마케팅커뮤니케이션',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'digital_heritage',
    departmentName: '디지털헤리티지',
    icon: '🏛️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 39,
      majorElective: 39,
      majorTotal: 42,
      generalElective: 54,
    },
    courses: [
      {
        courseCode: '11548',
        courseName: '디지털헤리티지의초대',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11548',
        courseName: '디지털헤리티지의초대',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01966',
        courseName: '동양사입문',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11774',
        courseName: '문화유산산업개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11772',
        courseName: '문화유산학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11773',
        courseName: '박물관학개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04206',
        courseName: '역사학개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07169',
        courseName: '한국사입문',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11776',
        courseName: '공공역사학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11775',
        courseName: '문화유산과생성형AI',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03437',
        courseName: '서양사입문',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11777',
        courseName: '역사콘텐츠입문',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09852',
        courseName: '영상인문학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07071',
        courseName: '한국고대사',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11279',
        courseName: '동양문화사',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11549',
        courseName: '디지털트윈과문화유산의가상복원',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11779',
        courseName: '역사판타지입문',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09851',
        courseName: '인문정보학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11778',
        courseName: '한국고고학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07194',
        courseName: '한국중세사',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11780',
        courseName: '서양문화사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11781',
        courseName: '아카이브입문',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11782',
        courseName: '역사게임의이론과실제',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07092',
        courseName: '한국근대사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07140',
        courseName: '한국미술사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11783',
        courseName: '빅데이터와문화유산',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07209',
        courseName: '한국현대사',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07962',
        courseName: '경기지역의역사와문화',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11550',
        courseName: '지리정보체계(HGIS)와문화유산',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'humanities',
    collegeName: '인문사회융합대학',
    departmentId: 'fire_admin',
    departmentName: '소방행정',
    icon: '🚒',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 45,
      majorElective: 45,
      majorTotal: 48,
      generalElective: 48,
    },
    courses: [
      {
        courseCode: '11694',
        courseName: '소방행정학',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11694',
        courseName: '소방행정학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11677',
        courseName: '소방과사회',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11786',
        courseName: '소방관계법규1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12614',
        courseName: '소방교육홍보론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12612',
        courseName: '소방전기론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11477',
        courseName: '소방학개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11699',
        courseName: '재난관리론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07295',
        courseName: '행정법총론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12613',
        courseName: '화재조사론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11787',
        courseName: '소방관계법규2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12616',
        courseName: '소방전기론2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12615',
        courseName: '소방행정실무',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07296',
        courseName: '행정법총론2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11701',
        courseName: '화재현상론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11678',
        courseName: '소방과학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12618',
        courseName: '소방기계론1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12617',
        courseName: '소방점검실무',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11697',
        courseName: '유체역학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11698',
        courseName: '융복합재난방재론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12620',
        courseName: '소방기계론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11690',
        courseName: '소방조직론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12619',
        courseName: '인명구조론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11700',
        courseName: '첨단산업화재예방론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11691',
        courseName: '소방체육',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11695',
        courseName: '안전과윤리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11696',
        courseName: '위험물질론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11686',
        courseName: '소방세미나',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11687',
        courseName: '소방심리학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12621',
        courseName: '응급처치론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'business_eng',
    collegeName: '경영공학대학',
    departmentId: 'economics',
    departmentName: '경제금융',
    icon: '💰',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 75,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00330',
        courseName: '거시경제학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00557',
        courseName: '경제수학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12739',
        courseName: '경제통계',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12740',
        courseName: '금융제도론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01507',
        courseName: '기업금융론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02654',
        courseName: '미시경제학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10335',
        courseName: '거시경제학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00553',
        courseName: '경제사',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10338',
        courseName: '금융자산투자의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10336',
        courseName: '미시경제학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12741',
        courseName: '발전경제학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07536',
        courseName: '화폐금융론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01266',
        courseName: '국제경제학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01270',
        courseName: '국제금융론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11796',
        courseName: '금융계량경제학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12394',
        courseName: '주식채권투자론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12395',
        courseName: '금융리스크관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12742',
        courseName: '디지털경제금융',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03173',
        courseName: '산업경제학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11420',
        courseName: '정치경제학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07066',
        courseName: '한국경제사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12396',
        courseName: '가상자산투자론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12743',
        courseName: '경제금융세미나1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12744',
        courseName: '금융자산투자의이해2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02894',
        courseName: '부동산경제학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12745',
        courseName: '파생금융상품론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07065',
        courseName: '한국경제론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12397',
        courseName: '경제금융세미나2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11264',
        courseName: '금융빅데이터분석',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01671',
        courseName: '노동경제학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07906',
        courseName: '세계지역경제론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05389',
        courseName: '재정학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12398',
        courseName: '투자심리와행동경제학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'business_eng',
    collegeName: '경영공학대학',
    departmentId: 'business',
    departmentName: '경영',
    icon: '📈',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 75,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00517',
        courseName: '경영수학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00535',
        courseName: '경영통계',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01508',
        courseName: '기업법',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02182',
        courseName: '마케팅원론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02833',
        courseName: '벤처창업론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08835',
        courseName: '인적자원관리',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09946',
        courseName: 'e-비즈니스전략',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '01275',
        courseName: '국제마케팅',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01410',
        courseName: '금융기관론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03627',
        courseName: '소비자행동론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05379',
        courseName: '재무관리',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05963',
        courseName: '조직행동론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00526',
        courseName: '경영정보시스템',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '00964',
        courseName: '광고론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01681',
        courseName: '노사관계론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02183',
        courseName: '마케팅조사론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08970',
        courseName: '생산운영관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12735',
        courseName: '인공지능응용서비스',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12394',
        courseName: '주식채권투자론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12392',
        courseName: 'HR애널리틱스',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00532',
        courseName: '경영조직론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10341',
        courseName: '데이터베이스론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '04961',
        courseName: '인터넷마케팅',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06175',
        courseName: '증권시장론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08840',
        courseName: '경영학세미나1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12393',
        courseName: '리더십',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05380',
        courseName: '재무분석',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09945',
        courseName: '전사적응용시스템',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08070',
        courseName: '파생금융상품',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10345',
        courseName: '판매유통관리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12736',
        courseName: 'ESG경영',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09190',
        courseName: '경영전략',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08841',
        courseName: '경영학세미나2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01270',
        courseName: '국제금융론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10342',
        courseName: '문화마케팅',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12737',
        courseName: '비즈니스인텔리전스총론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12738',
        courseName: '인공지능경영론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'business_eng',
    collegeName: '경영공학대학',
    departmentId: 'global_business',
    departmentName: '글로벌비즈니스',
    icon: '🌐',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 75,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09941',
        courseName: 'Business English1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12399',
        courseName: '국제협력의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09950',
        courseName: '글로벌비즈니스윤리와매너',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02313',
        courseName: '무역영어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02342',
        courseName: '무역학원론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12400',
        courseName: '문화와국제협력',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09942',
        courseName: 'Business English2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10952',
        courseName: 'FTA이론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12401',
        courseName: '국제기구의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08167',
        courseName: '국제물류론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01299',
        courseName: '국제통상론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10963',
        courseName: '다국적기업사례',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08963',
        courseName: '해외시장조사론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01259',
        courseName: '국제거래법',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12403',
        courseName: '글로벌경영전략',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09953',
        courseName: '글로벌마케팅',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12402',
        courseName: '디지털e-커머스원론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '02311',
        courseName: '무역실무',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11322',
        courseName: '사회적경제',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09768',
        courseName: 'NGO와국제협력',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00896',
        courseName: '관세론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12405',
        courseName: '글로벌인적자원관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12404',
        courseName: '디지털e-커머스사례연구',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10979',
        courseName: '무역결제론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07255',
        courseName: '해상보험론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10959',
        courseName: '국제무역정책론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12407',
        courseName: '국제협력세미나',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09202',
        courseName: '글로벌비즈니스세미나',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09957',
        courseName: '유럽지역과비즈니스',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07101',
        courseName: '한국무역론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12406',
        courseName: '환경과국제협력',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12409',
        courseName: 'AI와글로벌비즈니스혁신',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10958',
        courseName: '국제무역이론연습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10960',
        courseName: '글로벌기업환경론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12408',
        courseName: '글로벌비즈니스분쟁해결론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09961',
        courseName: '글로벌비즈니스협상론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10996',
        courseName: '아태지역과비즈니스',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'business_eng',
    collegeName: '경영공학대학',
    departmentId: 'accounting',
    departmentName: '회계',
    icon: '📊',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 75,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01508',
        courseName: '기업법',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03591',
        courseName: '세법개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07667',
        courseName: '회계원리연습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11521',
        courseName: '부가가치세회계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04668',
        courseName: '원가회계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05601',
        courseName: '전산회계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06169',
        courseName: '중급회계1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12434',
        courseName: 'AI퀀트투자',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00894',
        courseName: '관리회계',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09944',
        courseName: '법인세회계',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06170',
        courseName: '중급회계2',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07671',
        courseName: '회계이론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12435',
        courseName: 'AI데이터분석입문',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09962',
        courseName: '법인세연습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07657',
        courseName: '회계감사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07685',
        courseName: '회계학세미나',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08974',
        courseName: '고급관리회계',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00658',
        courseName: '고급회계',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08973',
        courseName: '소득세회계',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07672',
        courseName: '회계정보시스템',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03096',
        courseName: '비영리회계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11520',
        courseName: '재경관리연습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07686',
        courseName: '회계학연습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'business_eng',
    collegeName: '경영공학대학',
    departmentId: 'hospitality',
    departmentName: '호텔관광외식경영',
    icon: '🏨',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 75,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00546',
        courseName: '경영학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00591',
        courseName: '경제학원론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12436',
        courseName: '글로벌비즈니스론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10042',
        courseName: '서비스경영론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07661',
        courseName: '회계원리',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12413',
        courseName: '관광과환대산업',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12411',
        courseName: '구매관리',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09312',
        courseName: '비즈니스커뮤니케이션',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12410',
        courseName: '서비스경영통계및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12412',
        courseName: '외식프랜차이즈경영론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07443',
        courseName: '호텔경영론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12416',
        courseName: 'MICE산업과컨벤션기획실무',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12414',
        courseName: '글로벌음식문화',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12417',
        courseName: '문화관광자원론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12418',
        courseName: '서비스마케팅',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12746',
        courseName: '여행·항공실무론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12415',
        courseName: '유통관리론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12422',
        courseName: '관광소비자행동론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12419',
        courseName: '디지털마케팅',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12423',
        courseName: '문화관광콘텐츠개발',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12421',
        courseName: '서비스IMC브랜드관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12420',
        courseName: '식음료관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09966',
        courseName: '와인과소믈리에',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12424',
        courseName: 'K컬처이벤트관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12426',
        courseName: '고객관계관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11255',
        courseName: '관광빅데이터분석론',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12427',
        courseName: '서비스상품개발',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12425',
        courseName: '호스피탈리티광고홍보론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12429',
        courseName: '밴처창업론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12430',
        courseName: '서비스리더십',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12428',
        courseName: '호스피탈리티경영전략',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12433',
        courseName: 'AI창의프로젝트',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12432',
        courseName: '호스피탈리티인턴십',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12431',
        courseName: '호스피탈리티트렌드세미나',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'bioengineering',
    departmentName: '바이오공학과',
    icon: '🧬',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 15,
      majorElective: 51,
      majorTotal: 81,
      generalElective: 18,
    },
    courses: [
      {
        courseCode: '11644',
        courseName: '바이오제약의이해',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05084',
        courseName: '일반생물학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07576',
        courseName: '화학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12800',
        courseName: '바이오공학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05086',
        courseName: '일반생물학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07579',
        courseName: '화학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02633',
        courseName: '미생물학및실험1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10287',
        courseName: '바이오마케팅',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12699',
        courseName: '바이오환경공학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02917',
        courseName: '분석화학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12801',
        courseName: '생명정보학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03596',
        courseName: '세포생물학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08662',
        courseName: '유기화학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12700',
        courseName: 'AI/바이오빅데이터',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08660',
        courseName: '물리화학1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12701',
        courseName: '바이오배양공학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12803',
        courseName: '분자생물학및실험1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04765',
        courseName: '유전학및실험',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11002',
        courseName: '인체유전학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12802',
        courseName: '임상미생물학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10964',
        courseName: '단백질공학및실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12702',
        courseName: '바이오커뮤니케이션세미나1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09985',
        courseName: '분리정제기술및실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02945',
        courseName: '분자생물학2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03277',
        courseName: '생물통계학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03360',
        courseName: '생화학및실험1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09975',
        courseName: '인체면역학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09979',
        courseName: '바이오기기분석및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12703',
        courseName: '바이오커뮤니케이션세미나2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09980',
        courseName: '바이오품질관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03353',
        courseName: '생화학2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12804',
        courseName: '식물생명공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04757',
        courseName: '유전자공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11652',
        courseName: '자원생명공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01889',
        courseName: '독성약화학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12805',
        courseName: '바이오공학특수연구1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12704',
        courseName: '바이오규제과학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09614',
        courseName: '바이오신소재학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09992',
        courseName: '의학생명공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12705',
        courseName: '인체생리약리학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12806',
        courseName: '바이오공학특수연구2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12706',
        courseName: '바이오임상비임상론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09990',
        courseName: '바이오제약공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12807',
        courseName: '바이오제품개발론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09991',
        courseName: '바이오향장공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'civil_env_eng',
    departmentName: '건설환경공학',
    icon: '🏗️',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 30,
      majorElective: 45,
      majorTotal: 90,
      generalElective: 9,
    },
    courses: [
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07576',
        courseName: '화학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09996',
        courseName: '건설환경공학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06740',
        courseName: '통계학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09230',
        courseName: '환경에너지공학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '07809',
        courseName: 'CAD/CAM',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10377',
        courseName: '건설재료및실험',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00806',
        courseName: '공업수학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08704',
        courseName: '정역학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10376',
        courseName: '지질공학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06491',
        courseName: '측량학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06723',
        courseName: '토질역학및실험1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07599',
        courseName: '환경공학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03718',
        courseName: '수질오염개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03733',
        courseName: '수치해석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09997',
        courseName: '열역학개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11697',
        courseName: '유체역학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04852',
        courseName: '응용측량학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05372',
        courseName: '재료역학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06724',
        courseName: '토질역학및실험2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10378',
        courseName: '건설시공관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01120',
        courseName: '구조해석1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01523',
        courseName: '기초공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03128',
        courseName: '사진측정학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09024',
        courseName: '상수도공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03670',
        courseName: '수리학및실험',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03704',
        courseName: '수문학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06270',
        courseName: '철근콘크리트공학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10467',
        courseName: '해외건설시장과문화',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10379',
        courseName: '건설시공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01099',
        courseName: '구조동역학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01121',
        courseName: '구조해석2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12693',
        courseName: '글로벌건설커뮤니케이션',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08240',
        courseName: '암반공학및실험',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04836',
        courseName: '응용수리학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06198',
        courseName: '지형공간정보론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06289',
        courseName: '철근콘크리트및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09025',
        courseName: '하수도공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00236',
        courseName: 'P.S콘크리트',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00316',
        courseName: '강구조공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11589',
        courseName: '건설환경공학연습및실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12694',
        courseName: '디지털하천공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08694',
        courseName: '매트릭스구조해석및실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11649',
        courseName: '수자원시스템공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11650',
        courseName: '토목공학의이해',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '11590',
        courseName: '수자원스마트인프라설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09217',
        courseName: '지반공학설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08697',
        courseName: '터널설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09216',
        courseName: '토목구조물설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10380',
        courseName: '환경플랜트설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'env_energy_eng',
    departmentName: '환경에너지공학',
    icon: '🌿',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 30,
      majorElective: 48,
      majorTotal: 93,
      generalElective: 6,
    },
    courses: [
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07576',
        courseName: '화학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09996',
        courseName: '건설환경공학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06740',
        courseName: '통계학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09230',
        courseName: '환경에너지공학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '07809',
        courseName: 'CAD/CAM',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10377',
        courseName: '건설재료및실험',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00806',
        courseName: '공업수학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01730',
        courseName: '대기환경학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09997',
        courseName: '열역학개론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11591',
        courseName: '전기화학공학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08704',
        courseName: '정역학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10376',
        courseName: '지질공학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06491',
        courseName: '측량학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06723',
        courseName: '토질역학및실험1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07599',
        courseName: '환경공학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07612',
        courseName: '환경공학양론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12695',
        courseName: '환경화학개론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01723',
        courseName: '대기오염방지공학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09232',
        courseName: '대기오염실험',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03718',
        courseName: '수질오염개론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09231',
        courseName: '수질오염실험',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03733',
        courseName: '수치해석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10422',
        courseName: '에너지자원과미래',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09997',
        courseName: '열역학개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11697',
        courseName: '유체역학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04852',
        courseName: '응용측량학및실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05080',
        courseName: '일반생물학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05372',
        courseName: '재료역학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06724',
        courseName: '토질역학및실험2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06913',
        courseName: '폐기물처리공학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07638',
        courseName: '환경생태학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10378',
        courseName: '건설시공관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01120',
        courseName: '구조해석1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01523',
        courseName: '기초공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10423',
        courseName: '분석기기실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03128',
        courseName: '사진측정학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03227',
        courseName: '상수도공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09024',
        courseName: '상수도공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03670',
        courseName: '수리학및실험',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03704',
        courseName: '수문학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04240',
        courseName: '연소공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06270',
        courseName: '철근콘크리트공학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06461',
        courseName: '촉매공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08331',
        courseName: '폐기물실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10467',
        courseName: '해외건설시장과문화',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07623',
        courseName: '환경독성학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09234',
        courseName: '환경미생물학및실험',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10379',
        courseName: '건설시공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01099',
        courseName: '구조동역학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01121',
        courseName: '구조해석2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12693',
        courseName: '글로벌건설커뮤니케이션',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01718',
        courseName: '대기오염모델링',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09238',
        courseName: '바이오에너지공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10421',
        courseName: '신재생에너지',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08240',
        courseName: '암반공학및실험',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04713',
        courseName: '유기화학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04836',
        courseName: '응용수리학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08723',
        courseName: '전과정평가와친환경제품설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06198',
        courseName: '지형공간정보론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06289',
        courseName: '철근콘크리트및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06710',
        courseName: '토양오염',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08242',
        courseName: '하수도공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09025',
        courseName: '하수도공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07620',
        courseName: '환경단위조작',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07635',
        courseName: '환경반응공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00236',
        courseName: 'P.S콘크리트',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00316',
        courseName: '강구조공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11589',
        courseName: '건설환경공학연습및실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11527',
        courseName: '대기오염원격탐사',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12694',
        courseName: '디지털하천공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08694',
        courseName: '매트릭스구조해석및실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11649',
        courseName: '수자원시스템공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10425',
        courseName: '에너지자원처리공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11650',
        courseName: '토목공학의이해',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '09236',
        courseName: '폐기물에너지학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11472',
        courseName: '환경공학특강',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '11590',
        courseName: '수자원스마트인프라설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10428',
        courseName: '에너지공학특론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12696',
        courseName: '에너지화학응용',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11651',
        courseName: '에너지환경시스템디자인',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09217',
        courseName: '지반공학설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08697',
        courseName: '터널설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09216',
        courseName: '토목구조물설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10380',
        courseName: '환경플랜트설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'architecture',
    departmentName: '건축학',
    icon: '🏢',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 6,
      majorRequired: 41,
      majorElective: 36,
      majorTotal: 86,
      generalElective: 13,
    },
    courses: [
      {
        courseCode: '10552',
        courseName: '구조이야기',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01790',
        courseName: '도시계획개론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11280',
        courseName: '디자인이해1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10551',
        courseName: '통계이야기',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07809',
        courseName: 'CAD/CAM',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10546',
        courseName: '건축학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11281',
        courseName: '디자인이해2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '08285',
        courseName: '부동산학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00349',
        courseName: '건축계획1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10382',
        courseName: '건축론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00405',
        courseName: '건축설계1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '00468',
        courseName: '건축재료',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00494',
        courseName: '건축환경계획1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10395',
        courseName: '서양건축사(고전건축)',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '00350',
        courseName: '건축계획2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10383',
        courseName: '건축디지털표현1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '00407',
        courseName: '건축설계2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '00495',
        courseName: '건축환경계획2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01102',
        courseName: '구조역학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10396',
        courseName: '서양건축사(현대건축)',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00385',
        courseName: '건축구조해석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11242',
        courseName: '건축도시재생',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10384',
        courseName: '건축디지털표현2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '00390',
        courseName: '건축법규',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00400',
        courseName: '건축설계3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '08934',
        courseName: '건축시공기술',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11250',
        courseName: '공기조화설비',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07064',
        courseName: '한국건축사',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11241',
        courseName: '건물유틸리티및방재시스템',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10385',
        courseName: '건축디지털표현3',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10387',
        courseName: '건축디테일',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10386',
        courseName: '건축론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00401',
        courseName: '건축설계4',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '08265',
        courseName: '건축시공관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08933',
        courseName: '건축철근콘크리트',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01824',
        courseName: '도시설계론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00375',
        courseName: '건축구조설계',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10547',
        courseName: '건축설계5(캡스톤)',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 4,
        theoryHours: 3,
        practiceHours: 3,
      },
      {
        courseCode: '00478',
        courseName: '건축적산학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12697',
        courseName: '지속가능건축',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06257',
        courseName: '철골구조학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10381',
        courseName: 'Presentation',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00403',
        courseName: '건축설계6',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12698',
        courseName: '건축환경조절시스템설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10389',
        courseName: '실내인테리어디자인',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'urban_realestate',
    departmentName: '도시부동산학',
    icon: '🏙️',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 6,
      majorRequired: 36,
      majorElective: 36,
      majorTotal: 81,
      generalElective: 18,
    },
    courses: [
      {
        courseCode: '00186',
        courseName: 'GIS(도시지리정보체계실습)1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10555',
        courseName: '단독주거개발계획및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01795',
        courseName: '도시계획사',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10397',
        courseName: '부동산경제론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10554',
        courseName: '사회조사분석론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00187',
        courseName: 'GIS(도시지리정보체계실습)2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10557',
        courseName: '공동주거개발계획및실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10392',
        courseName: '부동산금융론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10556',
        courseName: '사회조사분석론2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08286',
        courseName: '오픈스페이스계획',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01084',
        courseName: '교통계획',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01712',
        courseName: '단지계획',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10391',
        courseName: '부동산투자론',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10558',
        courseName: '부동산평가및컨설팅론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08287',
        courseName: '토지이용계획론',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10548',
        courseName: '토지이용계획및실습',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10401',
        courseName: 'SOC와민자이론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10561',
        courseName: '국토및지역계획론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10549',
        courseName: '도시개발계획및실습',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01824',
        courseName: '도시설계론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02892',
        courseName: '부동산개발론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10560',
        courseName: '부동산중개및마케팅론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08292',
        courseName: '경관계획',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10562',
        courseName: '도시부동산융복합론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10400',
        courseName: '도시재생론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10398',
        courseName: '부동산관리론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10394',
        courseName: '도시부동산세미나',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'mechanical_eng',
    departmentName: '기계공학부',
    icon: '⚙️',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 21,
      majorElective: 48,
      majorTotal: 84,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00753',
        courseName: '고체역학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01441',
        courseName: '기계운동학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07804',
        courseName: '소프트웨어의활용1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08293',
        courseName: '열역학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08704',
        courseName: '정역학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08701',
        courseName: '창의적공학설계',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00555',
        courseName: '경제성공학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00758',
        courseName: '고체역학응용',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01442',
        courseName: '기계재료',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10053',
        courseName: '기술경영',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02007',
        courseName: '동역학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11332',
        courseName: '시스템해석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08336',
        courseName: '열역학응용',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11697',
        courseName: '유체역학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08705',
        courseName: '전산제도',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05917',
        courseName: '제조공학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04566',
        courseName: '컴퓨터프로그래밍',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00604',
        courseName: '계측공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01435',
        courseName: '기계설계기초',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01443',
        courseName: '기계재료응용및실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01451',
        courseName: '기계진동',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11592',
        courseName: '우주역학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04770',
        courseName: '유체기계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08337',
        courseName: '유체역학응용',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10407',
        courseName: '전기전자공학입문',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06575',
        courseName: '컴퓨터이용설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09221',
        courseName: '기계가공',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01436',
        courseName: '기계설계응용',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10404',
        courseName: '동적시뮬레이션응용설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11292',
        courseName: '로봇공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02252',
        courseName: '메카트로닉스',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03733',
        courseName: '수치해석',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04240',
        courseName: '연소공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04303',
        courseName: '열유체응용및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04304',
        courseName: '열전달',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08707',
        courseName: '유체시스템해석설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08105',
        courseName: '유한요소해석',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10563',
        courseName: '자동차부품힘측정및응용',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08708',
        courseName: '현장실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '00864',
        courseName: '공작기계',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11593',
        courseName: '기계공학을위한인공지능개론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01666',
        courseName: '냉동및공기조화',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03635',
        courseName: '소음공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04175',
        courseName: '에너지변환공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10406',
        courseName: '열전달응용',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05298',
        courseName: '자동제어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05301',
        courseName: '자동차공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10564',
        courseName: '자동차부품내구시험평가실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01434',
        courseName: '기계공학특강',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08341',
        courseName: '생산시스템해석설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08343',
        courseName: '에너지시스템해석설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10405',
        courseName: '열교환기설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04745',
        courseName: '유압공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10565',
        courseName: '자동차부품성능시험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'semiconductor_eng',
    departmentName: '반도체공학과',
    icon: '💡',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 18,
      majorElective: 48,
      majorTotal: 81,
      generalElective: 18,
    },
    courses: [
      {
        courseCode: '10969',
        courseName: '데이터코딩',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11007',
        courseName: '컴퓨팅사고',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01651',
        courseName: '기초회로기술및실험1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11646',
        courseName: '나노소재과학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02486',
        courseName: '물리전자1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06599',
        courseName: '컴퓨터프로그래밍1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08658',
        courseName: '회로이론1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01652',
        courseName: '기초회로기술및실험2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11647',
        courseName: '나노소재과학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02487',
        courseName: '물리전자2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06601',
        courseName: '컴퓨터프로그래밍2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07699',
        courseName: '회로이론2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00744',
        courseName: '고체물리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01593',
        courseName: '기초재료및실험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02754',
        courseName: '반도체물성',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11594',
        courseName: '반도체제어공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05377',
        courseName: '재료열역학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08664',
        courseName: '전자기학1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08280',
        courseName: '전자부품및재료',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10566',
        courseName: '전자폴리머',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08656',
        courseName: '전자회로1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06841',
        courseName: '파인세라믹스',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00759',
        courseName: '고체전자',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02755',
        courseName: '반도체소자',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05634',
        courseName: '전자기학2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11419',
        courseName: '전자재료및소자설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05679',
        courseName: '전자재료분석',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08657',
        courseName: '전자회로2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11595',
        courseName: '첨단전자소재',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08720',
        courseName: '플라즈마공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08281',
        courseName: '광전자소자',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02748',
        courseName: '반도체공정',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11596',
        courseName: '반도체공정및소자실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02760',
        courseName: '반도체재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07870',
        courseName: '전자세라믹스',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07869',
        courseName: '전자소자및회로실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06219',
        courseName: '집적회로',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09617',
        courseName: '태양전지공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09031',
        courseName: '디스플레이개론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02743',
        courseName: '박막공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08283',
        courseName: '반도체공정및소자시뮬레이션',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08282',
        courseName: '반도체패키징',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09786',
        courseName: '센서공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11648',
        courseName: '전자소자측정및분석',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06221',
        courseName: '집적회로및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'electrical_eng',
    departmentName: '전기공학',
    icon: '⚡',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06599',
        courseName: '컴퓨터프로그래밍1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06601',
        courseName: '컴퓨터프로그래밍2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09222',
        courseName: '디지털논리회로',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10579',
        courseName: '전기회로설계및실험1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08664',
        courseName: '전자기학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08658',
        courseName: '회로이론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02055',
        courseName: '디지털논리회로설계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08348',
        courseName: '반도체소자기초',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10581',
        courseName: '전기회로설계및실험2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05634',
        courseName: '전자기학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07699',
        courseName: '회로이론2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10418',
        courseName: '로봇제어프로그래밍1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05530',
        courseName: '전기에너지공학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07873',
        courseName: '전기응용설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08656',
        courseName: '전자회로1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08657',
        courseName: '전자회로2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10580',
        courseName: '전자회로설계및실험1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05912',
        courseName: '제어공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08346',
        courseName: '집적회로소자',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10419',
        courseName: '로봇제어프로그래밍2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08719',
        courseName: '반도체소자설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11754',
        courseName: '임베디드시스템및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05517',
        courseName: '전기기기',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05562',
        courseName: '전력공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10578',
        courseName: '전자회로설계및실험2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05916',
        courseName: '제어시스템설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10429',
        courseName: '기술과창업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11653',
        courseName: '영상처리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05508',
        courseName: '전기공학세미나',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08312',
        courseName: '전기안전공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05544',
        courseName: '전기재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05560',
        courseName: '전력계통공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11654',
        courseName: '전력전자공학및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11597',
        courseName: '전파제어및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08721',
        courseName: '지능제어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10420',
        courseName: 'PLC와지능제어실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00743',
        courseName: '고전압공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09042',
        courseName: '센서시스템설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05514',
        courseName: '전기공학특수과제',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11599',
        courseName: '전동화시스템및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11655',
        courseName: '전파제어응용및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'electronic_eng',
    departmentName: '전자공학',
    icon: '📡',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06599',
        courseName: '컴퓨터프로그래밍1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06601',
        courseName: '컴퓨터프로그래밍2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09222',
        courseName: '디지털논리회로',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08366',
        courseName: '신호및시스템',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10579',
        courseName: '전기회로설계및실험1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08664',
        courseName: '전자기학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08658',
        courseName: '회로이론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02055',
        courseName: '디지털논리회로설계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08348',
        courseName: '반도체소자기초',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10581',
        courseName: '전기회로설계및실험2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05634',
        courseName: '전자기학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06533',
        courseName: '컴퓨터구조',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10582',
        courseName: '확률및랜덤과정',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07699',
        courseName: '회로이론2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10418',
        courseName: '로봇제어프로그래밍1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08350',
        courseName: '마이크로파공학기초',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08352',
        courseName: '마이크로프로세서공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05530',
        courseName: '전기에너지공학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07873',
        courseName: '전기응용설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08656',
        courseName: '전자회로1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08657',
        courseName: '전자회로2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10580',
        courseName: '전자회로설계및실험1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05912',
        courseName: '제어공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08346',
        courseName: '집적회로소자',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08345',
        courseName: '통신이론의기초',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00972',
        courseName: '광전자공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11656',
        courseName: '디지털시스템설계및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02049',
        courseName: '디지털신호처리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10419',
        courseName: '로봇제어프로그래밍2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08719',
        courseName: '반도체소자설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04847',
        courseName: '응용전자공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11754',
        courseName: '임베디드시스템및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05305',
        courseName: '자료구조및알고리즘',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05517',
        courseName: '전기기기',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05562',
        courseName: '전력공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10578',
        courseName: '전자회로설계및실험2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05916',
        courseName: '제어시스템설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06753',
        courseName: '통신시스템설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08354',
        courseName: 'VLSI회로기초',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10429',
        courseName: '기술과창업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11297',
        courseName: '머신러닝',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11653',
        courseName: '영상처리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07881',
        courseName: '임베디드시스템',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05508',
        courseName: '전기공학세미나',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08312',
        courseName: '전기안전공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05544',
        courseName: '전기재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05560',
        courseName: '전력계통공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11654',
        courseName: '전력전자공학및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05752',
        courseName: '전파공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11597',
        courseName: '전파제어및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08721',
        courseName: '지능제어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06547',
        courseName: '컴퓨터네트워크',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10587',
        courseName: 'IoT스마트센서',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10420',
        courseName: 'PLC와지능제어실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00743',
        courseName: '고전압공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08138',
        courseName: '광통신공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10585',
        courseName: '네트워크프로그래밍',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10588',
        courseName: '디스플레이공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08357',
        courseName: '디지털집적회로설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02059',
        courseName: '디지털통신',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09042',
        courseName: '센서시스템설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05514',
        courseName: '전기공학특수과제',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11599',
        courseName: '전동화시스템및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05625',
        courseName: '전자공학특수연구',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11655',
        courseName: '전파제어응용및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10586',
        courseName: '초고속시스템설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'ict_eng',
    departmentName: '정보통신공학',
    icon: '📶',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 27,
      majorElective: 45,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06599',
        courseName: '컴퓨터프로그래밍1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06601',
        courseName: '컴퓨터프로그래밍2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09655',
        courseName: '객체지향프로그래밍',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09222',
        courseName: '디지털논리회로',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10579',
        courseName: '전기회로설계및실험1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08664',
        courseName: '전자기학1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08658',
        courseName: '회로이론1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01765',
        courseName: '데이터통신',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10629',
        courseName: '디지털논리설계실험',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02055',
        courseName: '디지털논리회로설계',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08348',
        courseName: '반도체소자기초',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08366',
        courseName: '신호및시스템',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10581',
        courseName: '전기회로설계및실험2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05634',
        courseName: '전자기학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06533',
        courseName: '컴퓨터구조',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07699',
        courseName: '회로이론2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10418',
        courseName: '로봇제어프로그래밍1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04663',
        courseName: '운영체제론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05530',
        courseName: '전기에너지공학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07873',
        courseName: '전기응용설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08656',
        courseName: '전자회로1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08657',
        courseName: '전자회로2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10580',
        courseName: '전자회로설계및실험1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05912',
        courseName: '제어공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08346',
        courseName: '집적회로소자',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06547',
        courseName: '컴퓨터네트워크',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06754',
        courseName: '통신이론',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01760',
        courseName: '데이터구조',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02049',
        courseName: '디지털신호처리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02059',
        courseName: '디지털통신',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10419',
        courseName: '로봇제어프로그래밍2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08150',
        courseName: '마이크로컴퓨터실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08719',
        courseName: '반도체소자설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11754',
        courseName: '임베디드시스템및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05517',
        courseName: '전기기기',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05562',
        courseName: '전력공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10578',
        courseName: '전자회로설계및실험2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05916',
        courseName: '제어시스템설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06219',
        courseName: '집적회로',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12707',
        courseName: '고급통신이론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10429',
        courseName: '기술과창업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11297',
        courseName: '머신러닝',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09657',
        courseName: '시스템프로그래밍',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11653',
        courseName: '영상처리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05508',
        courseName: '전기공학세미나',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08312',
        courseName: '전기안전공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05544',
        courseName: '전기재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05560',
        courseName: '전력계통공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11654',
        courseName: '전력전자공학및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11597',
        courseName: '전파제어및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08721',
        courseName: '지능제어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08884',
        courseName: '창의적공학설계1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10420',
        courseName: 'PLC와지능제어실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12809',
        courseName: '고급임베디드시스템공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '00743',
        courseName: '고전압공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10632',
        courseName: '네트워크설계및실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09042',
        courseName: '센서시스템설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12808',
        courseName: '인공지능응용',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05514',
        courseName: '전기공학특수과제',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11599',
        courseName: '전동화시스템및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11655',
        courseName: '전파제어응용및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11580',
        courseName: '지식재산개론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08886',
        courseName: '창의적공학설계2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'materials_eng',
    departmentName: '신소재공학',
    icon: '🔬',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 18,
      majorElective: 51,
      majorTotal: 84,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10589',
        courseName: '전공영어1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11141',
        courseName: '생활속의고분자',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05080',
        courseName: '일반생물학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10590',
        courseName: '전공영어2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09033',
        courseName: '재료과학및공학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05377',
        courseName: '재료열역학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00682',
        courseName: '고분자공학개론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08661',
        courseName: '물리화학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10601',
        courseName: '신소재와미래과학기술',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08663',
        courseName: '유기화학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09034',
        courseName: '재료과학및공학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00668',
        courseName: '고분자가공',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00701',
        courseName: '고분자물성학1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00721',
        courseName: '고분자화학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00794',
        courseName: '공업무기화학',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08710',
        courseName: '기기분석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11552',
        courseName: '반도체재료및물성',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08711',
        courseName: '신소재합성및실험1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11145',
        courseName: '열경화성고분자',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11553',
        courseName: '전자구조와재료화학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00702',
        courseName: '고분자물성학2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09035',
        courseName: '고분자재료공정및설계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11144',
        courseName: '고분자표면및계면',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00715',
        courseName: '고분자프로세스공학및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01473',
        courseName: '기능성고분자',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11554',
        courseName: '기능재료와원소',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12708',
        courseName: '배터리전기화학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08714',
        courseName: '신소재공학특강1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08713',
        courseName: '신소재합성및실험2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10603',
        courseName: '차세대탄소재료',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00704',
        courseName: '고분자복합재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00711',
        courseName: '고분자재료학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10429',
        courseName: '기술과창업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10417',
        courseName: '나노과학과기술',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10604',
        courseName: '나노복합재료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08716',
        courseName: '신소재공학특강2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12709',
        courseName: '에너지시스템과소재',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04187',
        courseName: '엘라스토머',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12710',
        courseName: '연성소재공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11555',
        courseName: '재료고체물리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11146',
        courseName: '바이오신소재',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12711',
        courseName: '연성소재물리화학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08305',
        courseName: '유변학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12712',
        courseName: '탄소중립소재화학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10605',
        courseName: '화공신소재특강(신소재)',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09037',
        courseName: '환경친화형도료설계',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'innovation_eng',
    collegeName: '혁신공과대학',
    departmentId: 'chemical_eng',
    departmentName: '화학공학',
    icon: '🧪',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 12,
      majorRequired: 15,
      majorElective: 54,
      majorTotal: 84,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '02522',
        courseName: '물리학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10589',
        courseName: '전공영어1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '07576',
        courseName: '화학및실험1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02525',
        courseName: '물리학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11141',
        courseName: '생활속의고분자',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05080',
        courseName: '일반생물학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10590',
        courseName: '전공영어2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07579',
        courseName: '화학및실험2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11551',
        courseName: '감성데이터구축및활용',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00812',
        courseName: '공업수학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08660',
        courseName: '물리화학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02911',
        courseName: '분석화학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08662',
        courseName: '유기화학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07489',
        courseName: '화공양론1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10591',
        courseName: '화학공학입문설계',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00814',
        courseName: '공업수학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08661',
        courseName: '물리화학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08663',
        courseName: '유기화학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07808',
        courseName: '응용생물학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09225',
        courseName: '화공기초응용및실험',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '07490',
        courseName: '화공양론2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10592',
        courseName: '화학공학전산기초',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10594',
        courseName: '기기분석1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02762',
        courseName: '반응공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04300',
        courseName: '열역학1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08320',
        courseName: '유기반응설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11697',
        courseName: '유체역학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10593',
        courseName: '응용생화학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08063',
        courseName: '화공전산응용',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10595',
        courseName: '기기분석2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03471',
        courseName: '석유화학공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04294',
        courseName: '열및물질전달',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04301',
        courseName: '열역학2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11014',
        courseName: '화장품화학공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07550',
        courseName: '화학공정제어',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09164',
        courseName: '화학공학응용및실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '07655',
        courseName: '환경화학공학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00729',
        courseName: '고분자화학공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10429',
        courseName: '기술과창업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10414',
        courseName: '나노화학공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08326',
        courseName: '반도체화학공정',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02908',
        courseName: '분리공정',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03310',
        courseName: '생물화학공학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07888',
        courseName: '이동현상',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09227',
        courseName: '화공시스템및실험',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10597',
        courseName: '화학공학특강1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08325',
        courseName: '공정경제성공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04109',
        courseName: '안전공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04173',
        courseName: '에너지공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10600',
        courseName: '유기공업화학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06462',
        courseName: '촉매반응공학',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10598',
        courseName: '화공신소재특강(화공)',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09168',
        courseName: '화학공학공정및실험',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10599',
        courseName: '화학공학특강2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'intelligent_sw',
    collegeName: '지능형SW대학',
    departmentId: 'ai_bigdata',
    departmentName: 'AI빅데이터',
    icon: '🤖',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 9,
      majorRequired: 21,
      majorElective: 54,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '10606',
        courseName: '소프트웨어적사고',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09969',
        courseName: '통계학1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12641',
        courseName: 'AI기초',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09655',
        courseName: '객체지향프로그래밍',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09971',
        courseName: '통계학2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01760',
        courseName: '데이터구조',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10968',
        courseName: '데이터시각화',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12624',
        courseName: '데이터탐색이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10977',
        courseName: '머신러닝1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03498',
        courseName: '선형대수학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05950',
        courseName: '조사방법론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11009',
        courseName: '파이썬데이터분석',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10953',
        courseName: 'R데이터분석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12643',
        courseName: '딥러닝개론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12644',
        courseName: '머신러닝프로젝트',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10607',
        courseName: '선형대수학과응용',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12642',
        courseName: '웹앱개발',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12646',
        courseName: 'AI진로설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01762',
        courseName: '데이터베이스',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12645',
        courseName: '딥러닝프로젝트',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11532',
        courseName: '라이프케어빅데이터분석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10989',
        courseName: '빅데이터분석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10997',
        courseName: '웹크롤자료분석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11473',
        courseName: '회귀분석',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12625',
        courseName: 'AI데이터마이닝',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12648',
        courseName: 'AI융합산업1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12647',
        courseName: 'AI융합연구1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10955',
        courseName: '공공데이터분석',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09018',
        courseName: '베이지안통계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08894',
        courseName: '알고리즘',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11406',
        courseName: '응용통계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12651',
        courseName: 'AI융합산업2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12649',
        courseName: 'AI융합연구2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12628',
        courseName: '설명기반AI',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12627',
        courseName: '음성인식',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12650',
        courseName: '자연어처리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12626',
        courseName: '통합통계예측분석',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12653',
        courseName: 'AI융합산업3',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12652',
        courseName: 'AI융합연구3',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12629',
        courseName: '금융스타트업AI',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03815',
        courseName: '시계열분석',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'intelligent_sw',
    collegeName: '지능형SW대학',
    departmentId: 'ai_software',
    departmentName: 'AI소프트웨어',
    icon: '💻',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 9,
      majorRequired: 21,
      majorElective: 54,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '12630',
        courseName: 'AI원리1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10954',
        courseName: 'R언어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04896',
        courseName: '이산수학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12631',
        courseName: 'AI원리2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10978',
        courseName: '머신러닝2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06533',
        courseName: '컴퓨터구조',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07590',
        courseName: '확률론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10970',
        courseName: '딥러닝응용1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12633',
        courseName: '강화학습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10971',
        courseName: '딥러닝응용2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10990',
        courseName: '빅데이터플랫폼',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12632',
        courseName: '생성형AI',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12636',
        courseName: 'AI소프트웨어개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12634',
        courseName: 'MLOps',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12635',
        courseName: '바이오의료AI',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10619',
        courseName: '컴퓨터비전',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12637',
        courseName: 'AI원리3',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12640',
        courseName: 'AI자동화시스템',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12638',
        courseName: '멀티모달AI',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12639',
        courseName: '제조산업AI',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'intelligent_sw',
    collegeName: '지능형SW대학',
    departmentId: 'computer_science',
    departmentName: '컴퓨터공학',
    icon: '🖥️',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 9,
      majorRequired: 24,
      majorElective: 51,
      majorTotal: 87,
      generalElective: 12,
    },
    courses: [
      {
        courseCode: '09970',
        courseName: 'C언어',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10611',
        courseName: 'ICT개론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03747',
        courseName: '수학1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12681',
        courseName: '네트워크기초',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02053',
        courseName: '디지털논리설계',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10606',
        courseName: '소프트웨어적사고',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '03751',
        courseName: '수학2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12682',
        courseName: '객체지향언어및실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01760',
        courseName: '데이터구조',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02048',
        courseName: '디지털시스템응용및실험',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09040',
        courseName: '디지털영상처리',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04686',
        courseName: '웹디자인',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04896',
        courseName: '이산수학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12796',
        courseName: '인공지능기초',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01765',
        courseName: '데이터통신',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08894',
        courseName: '알고리즘',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12797',
        courseName: '운영체제',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12683',
        courseName: '인공지능활용',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06533',
        courseName: '컴퓨터구조',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06544',
        courseName: '컴퓨터그래픽스',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03650',
        courseName: '소프트웨어공학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12684',
        courseName: '소프트웨어프로젝트',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09657',
        courseName: '시스템프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10612',
        courseName: '임베디드소프트웨어실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12685',
        courseName: '정보보호',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06547',
        courseName: '컴퓨터네트워크',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10619',
        courseName: '컴퓨터비전',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12798',
        courseName: 'IoT설계실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12688',
        courseName: '네트워크설계및응용',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01762',
        courseName: '데이터베이스',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12687',
        courseName: '디지털미디어컴퓨팅',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12689',
        courseName: '시큐어코딩',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12686',
        courseName: '인공지능프로젝트',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10614',
        courseName: '창업실무',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12799',
        courseName: '디지털미디어프로그래밍',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12691',
        courseName: '소프트웨어보안',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09633',
        courseName: '졸업프로젝트',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10616',
        courseName: '캡스톤설계1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06522',
        courseName: '컴파일러구성',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12690',
        courseName: '클라우드컴퓨팅',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12692',
        courseName: '게임프로젝트',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10468',
        courseName: '빅데이터정보검색',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08866',
        courseName: '자유전공',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10617',
        courseName: '캡스톤설계2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06532',
        courseName: '컴퓨터과학특강',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'intelligent_sw',
    collegeName: '지능형SW대학',
    departmentId: 'info_security',
    departmentName: '정보보안',
    icon: '🔐',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 36,
      majorElective: 39,
      majorTotal: 78,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '09970',
        courseName: 'C언어',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12665',
        courseName: '정보보호기술개론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12664',
        courseName: '파이썬',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12667',
        courseName: 'IT프로젝트1',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00191',
        courseName: 'JAVA',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12666',
        courseName: '리눅스',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '04896',
        courseName: '이산수학',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06547',
        courseName: '컴퓨터네트워크',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12630',
        courseName: 'AI원리1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10638',
        courseName: 'C++',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12668',
        courseName: 'IT프로젝트2기획및설계',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12669',
        courseName: '고급JAVA',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12670',
        courseName: '기계학습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '01762',
        courseName: '데이터베이스',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08893',
        courseName: '소프트웨어설계',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05303',
        courseName: '자료구조',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12671',
        courseName: '풀스택프로그래밍',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10484',
        courseName: '현대암호론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12631',
        courseName: 'AI원리2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12674',
        courseName: 'IT프로젝트2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10585',
        courseName: '네트워크프로그래밍',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08619',
        courseName: '데이터보안',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09643',
        courseName: '모바일프로그래밍',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08894',
        courseName: '알고리즘',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06533',
        courseName: '컴퓨터구조',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09635',
        courseName: '현대암호응용',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12677',
        courseName: 'AI데이터응용프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12675',
        courseName: 'IT프로젝트3기획및설계',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11226',
        courseName: 'IoT시스템응용및프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08677',
        courseName: '네트워크보안',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10486',
        courseName: '데이터베이스설계및관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04663',
        courseName: '운영체제론',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11398',
        courseName: '웹보안',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12655',
        courseName: '정보보안법의이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12676',
        courseName: '프로그램분석및시험',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12678',
        courseName: 'AI바이브프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12679',
        courseName: 'IT프로젝트3',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '11225',
        courseName: 'IoT보안',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09642',
        courseName: '데이터베이스보안',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10493',
        courseName: '보안프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12680',
        courseName: '비전식별및응용',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08371',
        courseName: '시스템보안',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09657',
        courseName: '시스템프로그래밍',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10339',
        courseName: '위험관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11222',
        courseName: 'AI보안',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10492',
        courseName: '디지털포렌직스',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12662',
        courseName: '보안관제및로그분석',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10488',
        courseName: '악성코드분석',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12663',
        courseName: '취약점분석및모의해킹',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12661',
        courseName: '침입탐지와차단시스템',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 4,
      },
    ],
  },
  {
    collegeId: 'intelligent_sw',
    collegeName: '지능형SW대학',
    departmentId: 'security_mgmt',
    departmentName: '보안관리',
    icon: '🛡️',
    graduationCredits: 130,
    liberalArtsTotal: 31,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 12,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 36,
      majorElective: 39,
      majorTotal: 78,
      generalElective: 21,
    },
    courses: [
      {
        courseCode: '12654',
        courseName: '개인정보보호암호기술이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08677',
        courseName: '네트워크보안',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10640',
        courseName: '정보보안관리1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12655',
        courseName: '정보보안법의이해',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11437',
        courseName: '클라우드보안',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12656',
        courseName: '시스템및네트워크프라이버시보호',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08371',
        courseName: '시스템보안',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10339',
        courseName: '위험관리',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10643',
        courseName: '정보보안관리2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12658',
        courseName: '개인정보보호기술적보호조치',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09654',
        courseName: '저작권보호와관리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12657',
        courseName: '정보보호관리체계인증',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12659',
        courseName: '정보보호산업기술최신동향',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'nursing',
    departmentName: '간호학과',
    icon: '💊',
    graduationCredits: 131,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 86,
      majorElective: 8,
      majorTotal: 97,
      generalElective: 0,
    },
    courses: [
      {
        courseCode: '10091',
        courseName: '인간성장과발달',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10023',
        courseName: '인간심리의분석',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09538',
        courseName: '간호학개론',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11633',
        courseName: '인체구조와기능',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09544',
        courseName: '간호통계학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10215',
        courseName: '기본간호학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10216',
        courseName: '기본간호학실습1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10528',
        courseName: '인간관계와의사소통',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11531',
        courseName: '패밀리헬스케어',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09543',
        courseName: '간호와영양',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10219',
        courseName: '기본간호학2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10220',
        courseName: '기본간호학실습2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11721',
        courseName: '다문화의이해',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09548',
        courseName: '병태생리학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10011',
        courseName: '아동간호학1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10032',
        courseName: '약물의기전과효과',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09789',
        courseName: '간호윤리',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '09562',
        courseName: '모성간호학1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10531',
        courseName: '보건의료와간호정책',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10651',
        courseName: '비판적사고와간호과정',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09554',
        courseName: '성인간호학1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09555',
        courseName: '성인간호학실습1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '10013',
        courseName: '아동간호학2',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09559',
        courseName: '아동간호학실습',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09552',
        courseName: '건강교육과상담',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10020',
        courseName: '모성간호학2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11705',
        courseName: '보완대체간호',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09560',
        courseName: '성인간호학2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09561',
        courseName: '성인간호학실습2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09564',
        courseName: '정신간호학1',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11703',
        courseName: '정신간호학실습1',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09549',
        courseName: '지역사회간호학1',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11720',
        courseName: '지역사회간호학실습1',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09571',
        courseName: '간호관리학',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11712',
        courseName: '근거기반간호',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11635',
        courseName: '노인간호학',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11636',
        courseName: '모성간호학실습',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '10015',
        courseName: '성인간호학3',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10016',
        courseName: '성인간호학실습3',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09569',
        courseName: '정신간호학2',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11736',
        courseName: '정신간호학실습2',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '09556',
        courseName: '지역사회간호학2',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11713',
        courseName: '지역사회간호학실습2',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11735',
        courseName: '환자안전',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10022',
        courseName: '간호관리학실습',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '10652',
        courseName: '간호와정보',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11634',
        courseName: '노인간호학실습',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '10021',
        courseName: '보건의료관계법규',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '10532',
        courseName: '보건프로그램개발및평가',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10017',
        courseName: '성인간호학4',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10031',
        courseName: '시뮬레이션통합실습',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10533',
        courseName: '임상추론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'child_family',
    departmentName: '아동가족복지학과',
    icon: '👶',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 12,
      majorElective: 54,
      majorTotal: 69,
      generalElective: 27,
    },
    courses: [
      {
        courseCode: '00290',
        courseName: '가족관계',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11176',
        courseName: '사회복지학개론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09796',
        courseName: '영유아발달',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04930',
        courseName: '인간행동과사회환경',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09668',
        courseName: '가족과문화',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08736',
        courseName: '보육학개론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09797',
        courseName: '아동미술',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09043',
        courseName: '자원봉사론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '06317',
        courseName: '청소년복지론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08689',
        courseName: '건강가정론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08724',
        courseName: '놀이지도',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09663',
        courseName: '보육교사론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03150',
        courseName: '사회복지실천론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03203',
        courseName: '상담심리학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09795',
        courseName: '아동권리와복지',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06065',
        courseName: '주거학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10223',
        courseName: '프로그램개발과평가',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '00295',
        courseName: '가족복지론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03149',
        courseName: '사회복지실천기술론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03153',
        courseName: '사회복지행정론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09798',
        courseName: '아동생활지도',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08725',
        courseName: '언어지도',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09664',
        courseName: '영유아교수방법론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '06190',
        courseName: '지역사회복지론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09374',
        courseName: '가정교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00300',
        courseName: '가족생활교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08737',
        courseName: '보육과정',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12494',
        courseName: '사례관리론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03151',
        courseName: '사회복지정책론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04070',
        courseName: '심리검사',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09799',
        courseName: '아동안전관리',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09045',
        courseName: '장애인복지론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '00262',
        courseName: '가정관리학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09375',
        courseName: '가정교과교재연구및지도법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03152',
        courseName: '사회복지조사론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03154',
        courseName: '사회복지현장실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09800',
        courseName: '아동관찰및행동연구',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '04095',
        courseName: '아동상담',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11177',
        courseName: '가족상담및가족치료',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11522',
        courseName: '부모교육론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11178',
        courseName: '사회복지법제와실천',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08727',
        courseName: '아동건강교육',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09819',
        courseName: '아동수학지도',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09376',
        courseName: '가정교과논리및논술',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '01682',
        courseName: '노인복지론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02848',
        courseName: '보육실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09667',
        courseName: '아동음악',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05810',
        courseName: '정신건강론',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'fashion_design_life',
    departmentName: '의류학과',
    icon: '👗',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 24,
      majorElective: 33,
      majorTotal: 60,
      generalElective: 36,
    },
    courses: [
      {
        courseCode: '01585',
        courseName: '기초의복구성',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11624',
        courseName: '복식디자인실습1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09670',
        courseName: '색채와패션',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09673',
        courseName: '패션도식화',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '04864',
        courseName: '의복구성1',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09671',
        courseName: '인체드로잉',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11627',
        courseName: '복식디자인실습2',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11523',
        courseName: '의류소재의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04865',
        courseName: '의복구성2',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08402',
        courseName: '패션드로잉',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06866',
        courseName: '패션마케팅',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06868',
        courseName: '패션머천다이징',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '08408',
        courseName: '비주얼머천다이징',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08668',
        courseName: '테일러링',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11524',
        courseName: '패션디자인캐드1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11630',
        courseName: '패션머천다이징실무',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '07027',
        courseName: '피복재료학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08404',
        courseName: '현대패션사',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11625',
        courseName: '의복과환경',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '05288',
        courseName: '입체재단',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11525',
        courseName: '패션디자인캐드2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12495',
        courseName: '패션프로모션기획',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '07149',
        courseName: '한국복식사',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '07228',
        courseName: '한복구성1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '03428',
        courseName: '서양복식사',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04883',
        courseName: '의상사회심리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06211',
        courseName: '직물학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11526',
        courseName: '테크니컬디자인',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12496',
        courseName: '패션e-비즈니스',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11632',
        courseName: '그린패션디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12759',
        courseName: '캡스톤디자인제작1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11626',
        courseName: '패션유통',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11628',
        courseName: '그린패션디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12497',
        courseName: '브랜드런칭프로젝트',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11629',
        courseName: '유니버설패션디자인',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08405',
        courseName: '의류소재개발',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12499',
        courseName: '캡스톤디자인3',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12498',
        courseName: '캡스톤디자인제작2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '07229',
        courseName: '한복구성2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'food_nutrition',
    departmentName: '식품영양학과',
    icon: '🍎',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 30,
      majorElective: 33,
      majorTotal: 66,
      generalElective: 30,
    },
    courses: [
      {
        courseCode: '03931',
        courseName: '식생활문화',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05941',
        courseName: '조리원리및실험1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11600',
        courseName: '지속가능한식생활과건강',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '00876',
        courseName: '공중보건학',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08193',
        courseName: '유기화학',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08412',
        courseName: '한국조리및실험',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09138',
        courseName: '기초영양학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09677',
        courseName: '식품미생물학및실험',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09527',
        courseName: '식품학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04069',
        courseName: '실험조리',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09143',
        courseName: '단체급식관리',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09821',
        courseName: '생리학1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10994',
        courseName: '식품분석및실험',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03961',
        courseName: '식품위생학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03970',
        courseName: '식품화학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04409',
        courseName: '영양교육',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05946',
        courseName: '조리원리및실험2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09822',
        courseName: '생리학2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09141',
        courseName: '생애주기영양학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03350',
        courseName: '생화학1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09582',
        courseName: '영양판정',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09139',
        courseName: '고급영양학',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '01414',
        courseName: '급식경영학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03353',
        courseName: '생화학2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10993',
        courseName: '식품가공및저장학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11333',
        courseName: '식품위생관계법규',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04422',
        courseName: '영양학실험',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06191',
        courseName: '지역사회영양학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09144',
        courseName: '식사요법및실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03930',
        courseName: '식생활관리학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08414',
        courseName: '식품품질관리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '05281',
        courseName: '임상영양학',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08411',
        courseName: '건강기능식품',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11545',
        courseName: '식품영양정보관리',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09145',
        courseName: '영양사현장실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '08415',
        courseName: '최신영양정보연구',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'sports_science',
    departmentName: '체육학',
    icon: '🏃',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 33,
      majorElective: 45,
      majorTotal: 81,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '10658',
        courseName: '생활영어',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03767',
        courseName: '스포츠과학론',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08904',
        courseName: '컴퓨터활용',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04800',
        courseName: '육상1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06395',
        courseName: '체조1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '07196',
        courseName: '한국체육사',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10660',
        courseName: '검도1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03712',
        courseName: '수영1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03792',
        courseName: '스포츠심리학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10663',
        courseName: '스포츠윤리',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04648',
        courseName: '운동생리학1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10297',
        courseName: '운동역학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10661',
        courseName: '웨이트트레이닝1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04733',
        courseName: '유도1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10662',
        courseName: '유아체육론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06470',
        courseName: '축구1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06509',
        courseName: '캠핑',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06648',
        courseName: '태권도1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06660',
        courseName: '테니스1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10664',
        courseName: '검도2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00773',
        courseName: '골프1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '01696',
        courseName: '농구1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '02807',
        courseName: '배구1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '02813',
        courseName: '배드민턴1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12492',
        courseName: '생활스포츠지도사의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03763',
        courseName: '스키1',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10667',
        courseName: '스포츠교육학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11528',
        courseName: '스포츠동작및경기분석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03777',
        courseName: '스포츠사회학',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10665',
        courseName: '웨이트트레이닝2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10659',
        courseName: '응급처치',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06379',
        courseName: '체육측정평가',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06474',
        courseName: '축구2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06649',
        courseName: '태권도2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '01697',
        courseName: '농구2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '02808',
        courseName: '배구2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '02814',
        courseName: '배드민턴2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04661',
        courseName: '운동학습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10666',
        courseName: '유소년체육실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06374',
        courseName: '체육철학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06396',
        courseName: '체조2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '09726',
        courseName: '트레이닝방법론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06835',
        courseName: '특수체육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10347',
        courseName: '스포츠마케팅',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04111',
        courseName: '안전교육',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04126',
        courseName: '야외교육론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04734',
        courseName: '유도2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10669',
        courseName: '장애인체육실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06382',
        courseName: '체육통계',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '08430',
        courseName: '체육행정관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06661',
        courseName: '테니스2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10672',
        courseName: '국제비교체육론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10670',
        courseName: '복지사회와건강과학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09684',
        courseName: '스포츠와미디어',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10671',
        courseName: '체육직무역량',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12488',
        courseName: '스포츠비즈니스커뮤니케이션',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10674',
        courseName: '체육실무영어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10675',
        courseName: '체육졸업실기',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06391',
        courseName: '체육학연구법',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'leisure_sports',
    departmentName: '레저스포츠',
    icon: '⛷️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 33,
      majorElective: 45,
      majorTotal: 81,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '10678',
        courseName: '뉴스포츠',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12473',
        courseName: '레저스포츠스폰서십',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12474',
        courseName: '레저스포츠의이해',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10676',
        courseName: '산악레저스포츠',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12475',
        courseName: '수상인명구조실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12476',
        courseName: '레저스포츠창업론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10684',
        courseName: '레저스포츠투어리즘',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03713',
        courseName: '수영2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12477',
        courseName: '스포츠경영관리사의이해',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11528',
        courseName: '스포츠동작및경기분석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '06644',
        courseName: '탁구1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10681',
        courseName: '필라테스',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12480',
        courseName: 'e스포츠이론과실제',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00774',
        courseName: '골프2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10688',
        courseName: '레저스포츠경영론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12479',
        courseName: '레저스포츠이벤트 기획론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12481',
        courseName: '스포츠마케팅조사방법론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10690',
        courseName: '스포츠와IT',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03803',
        courseName: '승마',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12478',
        courseName: '아웃도어레저실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10686',
        courseName: '요트',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '06645',
        courseName: '탁구2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12484',
        courseName: 'GX',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12483',
        courseName: '국제스포츠시장분석',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10694',
        courseName: '레저스포츠산업론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10693',
        courseName: '레저스포츠지도법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '02885',
        courseName: '볼링',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10691',
        courseName: '생활댄스',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03764',
        courseName: '스키2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10696',
        courseName: '스킨스쿠버',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12482',
        courseName: '스포츠소비자심리및행동',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10698',
        courseName: '레저스포츠직무역량',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12487',
        courseName: '스포츠빅데이터분석',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12486',
        courseName: '스포츠조직관리',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12485',
        courseName: '차료레크리에이션1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10704',
        courseName: '레저스포츠실무영어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10705',
        courseName: '레저스포츠졸업실기',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12488',
        courseName: '스포츠비즈니스커뮤니케이션',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12489',
        courseName: '치료레크리에이션2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'lifecare_science',
    collegeName: '라이프케어사이언스대학',
    departmentId: 'exercise_health',
    departmentName: '운동건강관리',
    icon: '🏋️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 33,
      majorElective: 45,
      majorTotal: 81,
      generalElective: 15,
    },
    courses: [
      {
        courseCode: '10707',
        courseName: '건강체력평가',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10708',
        courseName: '노인체육론',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '04653',
        courseName: '운동영양학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10706',
        courseName: '치료레크리에이션실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '09678',
        courseName: '기능해부학',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09707',
        courseName: '스트레칭',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11528',
        courseName: '스포츠동작및경기분석',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '03774',
        courseName: '스포츠마사지',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04651',
        courseName: '운동생리학2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12490',
        courseName: '건강운동관리사의 이해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10709',
        courseName: '노인체육실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10711',
        courseName: '선수트레이너이론과실제',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10710',
        courseName: '운동부하검사및실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10295',
        courseName: '운동상해',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10288',
        courseName: '운동재활1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04659',
        courseName: '운동처방론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10293',
        courseName: '퍼스널트레이닝1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '09548',
        courseName: '병태생리학',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09712',
        courseName: '스포츠테이핑',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10073',
        courseName: '운동건강관리',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10712',
        courseName: '운동건강관리산업',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10300',
        courseName: '운동재활2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10713',
        courseName: '운동처방실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10714',
        courseName: '체형교정',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10301',
        courseName: '퍼스널트레이닝2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10715',
        courseName: '운동건강과보건및영양',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10716',
        courseName: '운동건강관리직무역량',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10718',
        courseName: '운동건강지도법',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10717',
        courseName: '운동과발육발달',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12488',
        courseName: '스포츠비즈니스커뮤니케이션',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10721',
        courseName: '운동건강관리실무영어',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10720',
        courseName: '운동건강관리연구법',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10722',
        courseName: '운동건강관리졸업실기',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'art_tech_composition',
    departmentName: '아트앤테크놀로지작곡과',
    icon: '🎵',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 23,
      majorElective: 44,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '01741',
        courseName: '대위법1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12583',
        courseName: '서양음악기초이론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12582',
        courseName: '시벨리우스기초실습',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12581',
        courseName: '시창과청음',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05481',
        courseName: '전공실기1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12584',
        courseName: '화성의이해1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '01154',
        courseName: '국악기실습1',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12538',
        courseName: '국악기초이론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '01743',
        courseName: '대위법2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12585',
        courseName: '시벨리우스심화실습',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05484',
        courseName: '전공실기2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12587',
        courseName: '화성의이해2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12589',
        courseName: 'DAW와사운드프로덕션1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12588',
        courseName: '건반화성1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12590',
        courseName: '공연예술실습1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00937',
        courseName: '관현악법1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03444',
        courseName: '서양음악사1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05485',
        courseName: '전공실기3',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12591',
        courseName: 'DAW와사운드프로덕션2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12792',
        courseName: '건반화성2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12592',
        courseName: '공연예술실습2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00938',
        courseName: '관현악법2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '01155',
        courseName: '국악기실습2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03445',
        courseName: '서양음악사2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05487',
        courseName: '전공실기4',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12593',
        courseName: '공연예술실습3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00939',
        courseName: '관현악법3',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10517',
        courseName: '음악교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '04816',
        courseName: '음악분석1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05325',
        courseName: '작곡법연습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05488',
        courseName: '전공실기5',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12594',
        courseName: '공연예술실습4',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '00940',
        courseName: '관현악법4',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10516',
        courseName: '음악교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '04817',
        courseName: '음악분석2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05326',
        courseName: '작곡법연습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05489',
        courseName: '전공실기6',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12595',
        courseName: 'DAW와사운드프로덕션3',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10518',
        courseName: '음악교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10515',
        courseName: '음악미학',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12596',
        courseName: '음향및레코딩의이해',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '08572',
        courseName: '재즈입문',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05490',
        courseName: '전공실기7',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06199',
        courseName: '지휘법1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12597',
        courseName: 'DAW와사운드프로덕션4',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11374',
        courseName: '연주캡스톤(작곡)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08573',
        courseName: '재즈이론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05491',
        courseName: '전공실기8',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06200',
        courseName: '지휘법2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'vocal',
    departmentName: '성악과',
    icon: '🎤',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 33,
      majorElective: 34,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '12563',
        courseName: '공연무대움직임1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03442',
        courseName: '서양음악기초이론1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03868',
        courseName: '시창과청음1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12564',
        courseName: '이태리어딕션및가곡1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05448',
        courseName: '전공실기1(성악)',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08746',
        courseName: '콘서트콰이어1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12565',
        courseName: '공연무대움직임2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03443',
        courseName: '서양음악기초이론2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03869',
        courseName: '시창과청음2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12566',
        courseName: '이태리어딕션및가곡2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05449',
        courseName: '전공실기2(성악)',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08747',
        courseName: '콘서트콰이어2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12568',
        courseName: '공연예술실습1(성악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12567',
        courseName: '독일어딕션및가곡1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03444',
        courseName: '서양음악사1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11327',
        courseName: '성악의이해1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03870',
        courseName: '시창과청음3',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04232',
        courseName: '연기법1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05450',
        courseName: '전공실기3(성악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08748',
        courseName: '콘서트콰이어3',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12570',
        courseName: '공연예술실습2(성악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12569',
        courseName: '독일어딕션및가곡2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03445',
        courseName: '서양음악사2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11328',
        courseName: '성악의이해2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03871',
        courseName: '시창과청음4',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '04233',
        courseName: '연기법2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05451',
        courseName: '전공실기4(성악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08749',
        courseName: '콘서트콰이어4',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12573',
        courseName: '공연예술실습3(성악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03553',
        courseName: '성악문헌1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12571',
        courseName: '오페라이해와실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10517',
        courseName: '음악교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05452',
        courseName: '전공실기5(성악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08751',
        courseName: '콘서트콰이어6',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12572',
        courseName: '프랑스어딕션및가곡1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12576',
        courseName: '공연예술실습4(성악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '03554',
        courseName: '성악문헌2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12574',
        courseName: '오페라이해와실습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10516',
        courseName: '음악교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05453',
        courseName: '전공실기6(성악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09972',
        courseName: '캡스톤디자인',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '08751',
        courseName: '콘서트콰이어6',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12575',
        courseName: '프랑스어딕션및가곡2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11455',
        courseName: '한국가곡',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12577',
        courseName: '무대연출이론과기초기술1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10758',
        courseName: '뮤지컬공연및제작기획1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12578',
        courseName: '영어딕션및가곡1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10518',
        courseName: '음악교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05454',
        courseName: '전공실기7(성악)',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10519',
        courseName: '합창지휘법1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12579',
        courseName: '무대연출이론과기초기술2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10759',
        courseName: '뮤지컬공연및제작기획2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11373',
        courseName: '연주캡스톤(성악)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12580',
        courseName: '영어딕션및가곡2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05455',
        courseName: '전공실기8(성악)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10520',
        courseName: '합창지휘법2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'piano',
    departmentName: '피아노과',
    icon: '🎹',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 31,
      majorElective: 36,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '03442',
        courseName: '서양음악기초이론1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03868',
        courseName: '시창과청음1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05466',
        courseName: '전공실기1(피아노)',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '03443',
        courseName: '서양음악기초이론2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '03869',
        courseName: '시창과청음2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05467',
        courseName: '전공실기2(피아노)',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12600',
        courseName: '공연예술실습1(피아노)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12599',
        courseName: '생애주기별음악심리학',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '03444',
        courseName: '서양음악사1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05468',
        courseName: '전공실기3(피아노)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12598',
        courseName: '초견및총보독법1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12793',
        courseName: '컴퓨터사보기초실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12601',
        courseName: '화성대위법의활용과분석1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12603',
        courseName: '공연예술실습2(피아노)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03445',
        courseName: '서양음악사2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05469',
        courseName: '전공실기4(피아노)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12602',
        courseName: '초견및총보독법2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12794',
        courseName: '컴퓨터사보심화실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12604',
        courseName: '화성대위법의활용과분석2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12607',
        courseName: '공연예술실습3(피아노)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12606',
        courseName: '미디음악프로그램기초실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10517',
        courseName: '음악교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05470',
        courseName: '전공실기5(피아노)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07030',
        courseName: '피아노문헌1',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '07032',
        courseName: '피아노반주법1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11453',
        courseName: '피아노앙상블1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12605',
        courseName: '화성대위법의활용과분석3',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12610',
        courseName: '공연예술실습4(피아노)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12609',
        courseName: '미디음악프로그램기초실습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10516',
        courseName: '음악교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '05471',
        courseName: '전공실기6(피아노)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07031',
        courseName: '피아노문헌2',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '07034',
        courseName: '피아노반주법2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11454',
        courseName: '피아노앙상블2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12608',
        courseName: '화성대위법의활용과분석4',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10518',
        courseName: '음악교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12611',
        courseName: '음향현장실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '05472',
        courseName: '전공실기7(피아노)',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07028',
        courseName: '피아노교수법1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11308',
        courseName: '문화예술창업론',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11375',
        courseName: '연주캡스톤(피아노)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05473',
        courseName: '전공실기8(피아노)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07029',
        courseName: '피아노교수법2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'orchestra',
    departmentName: '관현악과',
    icon: '🎻',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 29,
      majorElective: 38,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '08585',
        courseName: '관악/현악합주1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00942',
        courseName: '관현악합주1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12520',
        courseName: '서양음악기초이론통법1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04018',
        courseName: '실내악앙상블1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05431',
        courseName: '전공실기1(관현악)',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07524',
        courseName: '화성및건반화성1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08586',
        courseName: '관악/현악합주2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00944',
        courseName: '관현악합주2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12521',
        courseName: '서양음악기초이론통법2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04020',
        courseName: '실내악앙상블2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05432',
        courseName: '전공실기2(관현악)',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07526',
        courseName: '화성및건반화성2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12778',
        courseName: '공연예술실습1(관현악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08587',
        courseName: '관악/현악합주3',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00946',
        courseName: '관현악합주3',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '04023',
        courseName: '실내악앙상블3',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12522',
        courseName: '오케스트라레퍼토리연구1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '05433',
        courseName: '전공실기3(관현악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07528',
        courseName: '화성및건반화성3',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12779',
        courseName: '공연예술실습2(관현악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08588',
        courseName: '관악/현악합주4',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00948',
        courseName: '관현악합주4',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12525',
        courseName: '그룹티칭',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '04025',
        courseName: '실내악앙상블4',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12524',
        courseName: '오케스트라레퍼토리연구2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '05434',
        courseName: '전공실기4(관현악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '07530',
        courseName: '화성및건반화성4',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12780',
        courseName: '공연예술실습3(관현악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08589',
        courseName: '관악/현악합주5',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12528',
        courseName: '관현악문헌과악기론1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '00950',
        courseName: '관현악합주5',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12527',
        courseName: '오케스트라레퍼토리연구3',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10517',
        courseName: '음악교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05435',
        courseName: '전공실기5(관현악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12781',
        courseName: '공연예술실습4(관현악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08590',
        courseName: '관악/현악합주6',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12532',
        courseName: '관현악문헌과악기론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '00952',
        courseName: '관현악합주6',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12530',
        courseName: '무대음향이론',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12531',
        courseName: '오케스트라레퍼토리연구4',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10516',
        courseName: '음악교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05436',
        courseName: '전공실기6(관현악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12782',
        courseName: '공연예술실습5(관현악)',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08592',
        courseName: '관악/현악합주7',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '08591',
        courseName: '관현악합주7',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '03868',
        courseName: '시창과청음1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10518',
        courseName: '음악교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05437',
        courseName: '전공실기7(관현악)',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06199',
        courseName: '지휘법1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12783',
        courseName: '공연예술실습6(관현악)',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08593',
        courseName: '관악/현악합주8',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '00956',
        courseName: '관현악합주8',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03869',
        courseName: '시창과청음2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11371',
        courseName: '연주캡스톤(관현악)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12536',
        courseName: '음악창업과브랜드',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '05438',
        courseName: '전공실기8(관현악)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06200',
        courseName: '지휘법2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'korean_music',
    departmentName: '국악과',
    icon: '🥁',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 31,
      majorElective: 36,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '11537',
        courseName: '국악관현악과성악1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12784',
        courseName: '기초장단1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12583',
        courseName: '서양음악기초이론',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '03868',
        courseName: '시창과청음1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05440',
        courseName: '전공실기1(국악)',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12537',
        courseName: '정가실습',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12539',
        courseName: '경기민요실습',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11538',
        courseName: '국악관현악과성악2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '12538',
        courseName: '국악기초이론',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12785',
        courseName: '기초장단2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '03869',
        courseName: '시창과청음2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05441',
        courseName: '전공실기2(국악)',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12787',
        courseName: '공연예술실습1(국악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11539',
        courseName: '국악관현악과성악3',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '08601',
        courseName: '국악합주1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12540',
        courseName: '기보및채보1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '12786',
        courseName: '사물장단1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12542',
        courseName: '성악움직임실습1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05442',
        courseName: '전공실기3(국악)',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12541',
        courseName: '판소리실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12543',
        courseName: '한국음악예술사',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12789',
        courseName: '공연예술실습2(국악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11540',
        courseName: '국악관현악과성악4',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '08603',
        courseName: '국악합주2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12545',
        courseName: '기보및채보2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '12546',
        courseName: '남도민요실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12788',
        courseName: '사물장단2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12547',
        courseName: '성악움직임실습2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '05443',
        courseName: '전공실기4(국악)',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12553',
        courseName: 'AI음악교육설계론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12790',
        courseName: '공연예술실습3(국악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11541',
        courseName: '국악관현악과성악5',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10525',
        courseName: '국악교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12551',
        courseName: '국악합주3',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12550',
        courseName: '단소실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12552',
        courseName: '소리연기실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12549',
        courseName: '악보분석1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '05444',
        courseName: '전공실기5(국악)',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12791',
        courseName: '공연예술실습4(국악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11542',
        courseName: '국악관현악과성악6',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10526',
        courseName: '국악교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12557',
        courseName: '국악합주4',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12556',
        courseName: '단소실습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12558',
        courseName: '소리연기실습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12555',
        courseName: '악보분석2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05445',
        courseName: '전공실기6(국악)',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12561',
        courseName: '공연기획실무',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11543',
        courseName: '국악관현악과성악7',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10527',
        courseName: '국악교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12560',
        courseName: '문화예술정책리터러시',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '05446',
        courseName: '전공실기7(국악)',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12562',
        courseName: '공연예술컨텐츠기획',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11544',
        courseName: '국악관현악과성악8',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11372',
        courseName: '연주캡스톤(국악)',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05447',
        courseName: '전공실기8(국악)',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 1,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'film_art',
    departmentName: '영화예술',
    icon: '🎬',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 30,
      majorElective: 37,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '12767',
        courseName: '스크린과사유',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12516',
        courseName: '신화와상상력',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09239',
        courseName: '연극입문기초',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12766',
        courseName: '이야기와사운드',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09277',
        courseName: '관찰과상상',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '04216',
        courseName: '연극사',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '04575',
        courseName: '영화사',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12768',
        courseName: '영화제작테크놀로지실습',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11450',
        courseName: '프로덕션피치크리틱1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09280',
        courseName: '다큐멘터리제작실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11478',
        courseName: '사운드디자인실습1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '03830',
        courseName: '시나리오창작실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12770',
        courseName: '영화연출과인물표현',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12769',
        courseName: '촬영및조명실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11451',
        courseName: '프로덕션피치크리틱2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12771',
        courseName: 'AI편집실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11321',
        courseName: '사운드디자인실습2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11382',
        courseName: '영화분석세미나',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12772',
        courseName: '영화예술',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11386',
        courseName: '영화제작실습1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11452',
        courseName: '프로덕션피치크리틱3',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12773',
        courseName: 'AI시각효과',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11384',
        courseName: '영화연출스타일분석',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11387',
        courseName: '영화제작실습2',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12774',
        courseName: '장르와영화미학',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12517',
        courseName: '프로덕션피치크리틱4',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12776',
        courseName: '영화기획제작배급1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11388',
        courseName: '영화제작실습3',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12775',
        courseName: '촬영및DI실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12518',
        courseName: '프로덕션피치크리틱5',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11276',
        courseName: '독립프로젝트1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12777',
        courseName: '영화기획제작배급2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11389',
        courseName: '영화제작실습4',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 4,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12519',
        courseName: '프로덕션피치크리틱6',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11277',
        courseName: '독립프로젝트2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10786',
        courseName: '연극영화교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '11390',
        courseName: '영화제작실습5',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 4,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11423',
        courseName: '졸업논문및작품',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'acting',
    departmentName: '연기예술',
    icon: '🎭',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 19,
      majorElective: 48,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '11251',
        courseName: '공연예술프랙티컴',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09243',
        courseName: '기초연기1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09244',
        courseName: '분장실습1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09240',
        courseName: '이야기와이미지',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11474',
        courseName: '희곡분석실습1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09247',
        courseName: '기초연기2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11301',
        courseName: '무대미술입문실습',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '09242',
        courseName: '세계영화사',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '04216',
        courseName: '연극사',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09248',
        courseName: '연극제작실습기초',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11303',
        courseName: '무대미술조명',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08807',
        courseName: '뮤지컬노래연습1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09253',
        courseName: '연극제작실습1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '11396',
        courseName: '움직임1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '09252',
        courseName: '중급연기1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09251',
        courseName: '화술연구1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11475',
        courseName: '희곡분석실습2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11302',
        courseName: '무대미술제작',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08811',
        courseName: '뮤지컬노래연습2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11340',
        courseName: '연극연출실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09258',
        courseName: '연극제작실습2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '11397',
        courseName: '움직임2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09257',
        courseName: '중급연기2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08021',
        courseName: '화술연구2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09262',
        courseName: '고급연기1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08828',
        courseName: '공연스텝실습1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '01062',
        courseName: '교육연극',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09310',
        courseName: '뮤지컬노래연기실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 0,
        practiceHours: 4,
      },
      {
        courseCode: '09261',
        courseName: '뮤지컬안무실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09263',
        courseName: '뮤지컬제작실습',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09356',
        courseName: '연극영화교육론',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09267',
        courseName: '고급연기2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08832',
        courseName: '공연스텝실습2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '12762',
        courseName: '세익스피어극이해와실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09357',
        courseName: '연극영화교과교재연구및지도법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10790',
        courseName: '연극영화교수학습방법',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09268',
        courseName: '연극제작실습3',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12761',
        courseName: '희곡작법실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '09274',
        courseName: '공연스텝실습3',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 1,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '08028',
        courseName: '동양연극연구',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12763',
        courseName: '드라마투르그실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09275',
        courseName: '분장실습2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09270',
        courseName: '연극제작실습4',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '09266',
        courseName: '카메라연기1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12764',
        courseName: '현대연극의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09358',
        courseName: '연극영화교과논리및논술',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10786',
        courseName: '연극영화교육프로그램개발',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09271',
        courseName: '연극제작실습5',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 6,
      },
      {
        courseCode: '12765',
        courseName: '예술경영실습',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11423',
        courseName: '졸업논문및작품',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 1,
        theoryHours: 1,
        practiceHours: 0,
      },
      {
        courseCode: '09269',
        courseName: '카메라연기2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'music_tech',
    collegeName: '음악테크놀로지대학',
    departmentId: 'digital_content',
    departmentName: '디지털콘텐츠',
    icon: '📽️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 33,
      majorElective: 34,
      majorTotal: 70,
      generalElective: 26,
    },
    courses: [
      {
        courseCode: '08947',
        courseName: '문화콘텐츠의이해',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12500',
        courseName: '생성형AI콘텐츠제작기초',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11605',
        courseName: '영상제작입문',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12501',
        courseName: '창의적발상표현',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12503',
        courseName: '그래픽스기초',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12502',
        courseName: '디지털문화와미디어',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11376',
        courseName: '영상언어와서사',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12506',
        courseName: '2D그래픽스',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10830',
        courseName: '3D그래픽스1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10819',
        courseName: '과학기술과문화콘텐츠',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12505',
        courseName: '디지털영상편집1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12507',
        courseName: '문화콘텐츠기획론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10822',
        courseName: '신화와서사',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12504',
        courseName: '콘텐츠분석실습',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10831',
        courseName: '3D그래픽스2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12508',
        courseName: '디지털미디어경영론',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '12510',
        courseName: '디지털아트창작실습',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '12509',
        courseName: '디지털영상편집2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10816',
        courseName: '예술사와문화콘텐츠',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '11606',
        courseName: '이머시브미디어제작',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10837',
        courseName: '캐릭터디자인',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12512',
        courseName: '브랜드스토리텔링',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10829',
        courseName: '사운드디자인',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12511',
        courseName: '영상콘텐츠워크숍',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12760',
        courseName: '이머시브미디어스튜디오',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10846',
        courseName: '콘텐츠비지니스와마케팅',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10847',
        courseName: '콘텐츠산업과정책',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '12514',
        courseName: '뉴미디어광고제작',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12513',
        courseName: '디지털마케팅실습',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11298',
        courseName: '모바일과소셜미디어',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10844',
        courseName: '문화유산과글로벌콘텐츠',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12515',
        courseName: '융복합콘텐츠제작',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10843',
        courseName: '전시와공간스토리텔링',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10849',
        courseName: '글로벌콘텐츠포맷',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10845',
        courseName: '도시와문화콘텐츠',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10820',
        courseName: '졸업프로젝트1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '11435',
        courseName: '콘텐츠스타트업',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10850',
        courseName: '현장인턴쉽1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10825',
        courseName: '미래사회와디지털휴머니티',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '10821',
        courseName: '졸업프로젝트2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
      {
        courseCode: '10851',
        courseName: '현장인턴쉽2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 0,
        practiceHours: 3,
      },
    ],
  },
  {
    collegeId: 'design_art',
    collegeName: '디자인앤아트대학',
    departmentId: 'painting',
    departmentName: '회화',
    icon: '🎨',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 61,
      majorElective: 7,
      majorTotal: 71,
      generalElective: 25,
    },
    courses: [
      {
        courseCode: '09075',
        courseName: 'Art History1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08482',
        courseName: 'Digital Design1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09518',
        courseName: '드로잉1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '05995',
        courseName: '조형연구1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09062',
        courseName: 'Art History2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08484',
        courseName: 'Digital Design2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09523',
        courseName: '드로잉2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '05996',
        courseName: '조형연구2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09500',
        courseName: '영상1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12463',
        courseName: '재료학',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09443',
        courseName: '판화1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '06932',
        courseName: '표현기법1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11457',
        courseName: '한국미술의이해1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12753',
        courseName: '한국화1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09447',
        courseName: '회화1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12465',
        courseName: 'Color & Art',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12466',
        courseName: '미술교육론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09464',
        courseName: '영상2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09450',
        courseName: '판화2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08468',
        courseName: '표현기법2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11458',
        courseName: '한국미술의이해2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12754',
        courseName: '한국화2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09440',
        courseName: '회화2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12467',
        courseName: 'Immerse Art1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09491',
        courseName: '매체연구1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12468',
        courseName: '미술교수학습방법',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12469',
        courseName: '미술교육프로그램개발',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '09785',
        courseName: '조형예술론1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12755',
        courseName: '현대미술의이해1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10434',
        courseName: '현대민화1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09441',
        courseName: '회화3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12470',
        courseName: 'Immerse Art2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09497',
        courseName: '매체연구2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '09787',
        courseName: '조형예술론2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12756',
        courseName: '현대미술의이해2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10435',
        courseName: '현대민화2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09466',
        courseName: '회화4',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12471',
        courseName: '아트마케팅&브랜딩',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11424',
        courseName: '졸업작품연구1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 4,
        theoryHours: 2,
        practiceHours: 4,
      },
      {
        courseCode: '12757',
        courseName: '회화심화연구1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12472',
        courseName: '아트 포트폴리오',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11425',
        courseName: '졸업작품연구2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 4,
        theoryHours: 2,
        practiceHours: 4,
      },
      {
        courseCode: '12758',
        courseName: '회화심화연구2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'design_art',
    collegeName: '디자인앤아트대학',
    departmentId: 'sculpture',
    departmentName: '조소',
    icon: '🗿',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 43,
      majorElective: 25,
      majorTotal: 71,
      generalElective: 25,
    },
    courses: [
      {
        courseCode: '12751',
        courseName: '3D 모델링1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09481',
        courseName: '금속조1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09491',
        courseName: '매체연구1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10725',
        courseName: '인체모델링연구1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09488',
        courseName: '조형실기1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11457',
        courseName: '한국미술의이해1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12752',
        courseName: '3D 모델링2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09484',
        courseName: '금속조2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09497',
        courseName: '매체연구2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10726',
        courseName: '인체모델링연구2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09493',
        courseName: '조형실기2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11458',
        courseName: '한국미술의이해2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '00780',
        courseName: '공간조형1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12459',
        courseName: '디지털조형1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02225',
        courseName: '매체연구3',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11421',
        courseName: '조형실기3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11469',
        courseName: '현대작가연구1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '00781',
        courseName: '공간조형2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12460',
        courseName: '디지털조형2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02226',
        courseName: '매체연구4',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11422',
        courseName: '조형실기4',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11470',
        courseName: '현대작가연구2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12461',
        courseName: '미래설계프로젝트1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09471',
        courseName: '자유제작실기1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09469',
        courseName: '특수실기연구1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09508',
        courseName: '형상표현1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12462',
        courseName: '미래설계프로젝트2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09476',
        courseName: '자유제작실기2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09473',
        courseName: '특수실기연구2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09514',
        courseName: '형상표현2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'design_art',
    collegeName: '디자인앤아트대학',
    departmentId: 'comm_design',
    departmentName: '커뮤니케이션디자인',
    icon: '✏️',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 54,
      majorElective: 23,
      majorTotal: 80,
      generalElective: 16,
    },
    courses: [
      {
        courseCode: '10081',
        courseName: '2D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10082',
        courseName: '3D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08537',
        courseName: 'Art History',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08482',
        courseName: 'Digital Design1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10944',
        courseName: 'Color&Design',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11708',
        courseName: 'Design Theory',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08490',
        courseName: 'Form & Identity',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11724',
        courseName: 'Intro. to Design',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11733',
        courseName: '기초일러스트레이션',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08489',
        courseName: '기초타이포그래피',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10448',
        courseName: 'Design & Business',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09069',
        courseName: 'Design Studio1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08484',
        courseName: 'Digital Design2',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11725',
        courseName: 'Intro. to Media Design',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08492',
        courseName: '인쇄프로세스',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12438',
        courseName: '일러스트레이션스튜디오',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08481',
        courseName: '타이포그래피',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12443',
        courseName: 'AI Research',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '12442',
        courseName: 'Contents Design',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09071',
        courseName: 'Design Studio2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12440',
        courseName: 'Digital Photography',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08491',
        courseName: 'Editorial Design',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12441',
        courseName: 'Motion Graphics1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12439',
        courseName: 'UXUI Studio1',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12445',
        courseName: 'AI Studio',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12444',
        courseName: 'Design & Branding1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09055',
        courseName: 'Package Design1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09972',
        courseName: '캡스톤디자인',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12449',
        courseName: 'AI video',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12447',
        courseName: 'Design & Branding2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10446',
        courseName: 'Design Studio3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12446',
        courseName: 'Motion Graphics2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09058',
        courseName: 'Package Design2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12448',
        courseName: 'UXUI Studio2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10457',
        courseName: 'Adv. Branding1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12451',
        courseName: 'Adv. Contents Design',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12453',
        courseName: 'Design Photography',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12450',
        courseName: 'Digital Contents',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12747',
        courseName: 'Digital Media',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11710',
        courseName: 'Print Media',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12452',
        courseName: 'Prototyping',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09633',
        courseName: '졸업프로젝트',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10458',
        courseName: 'Adv. Branding2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12454',
        courseName: 'Design Presentation',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10728',
        courseName: 'Portfolio 제작',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12748',
        courseName: 'Promotion Design',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'design_art',
    collegeName: '디자인앤아트대학',
    departmentId: 'fashion_design',
    departmentName: '패션디자인',
    icon: '👒',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 67,
      majorElective: 10,
      majorTotal: 80,
      generalElective: 16,
    },
    courses: [
      {
        courseCode: '10081',
        courseName: '2D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10082',
        courseName: '3D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09075',
        courseName: 'Art History1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08482',
        courseName: 'Digital Design1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09062',
        courseName: 'Art History2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '12749',
        courseName: 'Basic Sewing Techniques',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10944',
        courseName: 'Color&Design',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08484',
        courseName: 'Digital Design2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12750',
        courseName: 'Intro. to Fashion Design',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '08511',
        courseName: 'Draping1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09080',
        courseName: 'Fabric Study',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08512',
        courseName: 'Fashion Design1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09065',
        courseName: 'Fashion Drawing1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11224',
        courseName: 'Fashion History',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '09063',
        courseName: 'Pattern Design1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08524',
        courseName: '디지털패션스튜디오1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11602',
        courseName: '로컬상품기획및브랜딩',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10950',
        courseName: 'Design&Designers',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08517',
        courseName: 'Draping2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08515',
        courseName: 'Fashion Design2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09083',
        courseName: 'Fashion Drawing2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09067',
        courseName: 'Pattern Design2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08525',
        courseName: '디지털패션스튜디오2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11601',
        courseName: '로컬아트스튜디오2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '12455',
        courseName: 'Creative Fashion Studio',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08518',
        courseName: 'Fashion Design3',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10735',
        courseName: '니트디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08668',
        courseName: '테일러링',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11445',
        courseName: '패션마케팅&VMD',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10466',
        courseName: '패턴캐드',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09086',
        courseName: '한국전통복식스터디',
        category: 'career',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09068',
        courseName: 'Fashion Design4',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '12456',
        courseName: 'Fashion Start-up',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 1,
      },
      {
        courseCode: '10737',
        courseName: '니트디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '02028',
        courseName: '디자인&컨스트럭션',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11010',
        courseName: '패션&디지털클로딩',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08514',
        courseName: '패션소재개발',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10736',
        courseName: '패턴캐드2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10946',
        courseName: 'Critic&Design',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09069',
        courseName: 'Design Studio1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11234',
        courseName: 'Senior Studio',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12499',
        courseName: '캡스톤디자인3',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10945',
        courseName: 'Creative Construction',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09071',
        courseName: 'Design Studio2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09098',
        courseName: '인턴쉽',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '12458',
        courseName: '캡스톤디자인4',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06925',
        courseName: '포트폴리오',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'design_art',
    collegeName: '디자인앤아트대학',
    departmentId: 'craft_design',
    departmentName: '공예디자인',
    icon: '🖶',
    graduationCredits: 130,
    liberalArtsTotal: 34,
    liberalArtsBreakdown: {
      coreLiberal: 6,
      basicLiberal: 15,
      electiveLiberal: 12,
      characterEd: 1,
    },
    majorCredits: {
      careerSeminar: 3,
      majorBasicLiberal: 0,
      majorRequired: 53,
      majorElective: 24,
      majorTotal: 80,
      generalElective: 16,
    },
    courses: [
      {
        courseCode: '10081',
        courseName: '2D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10082',
        courseName: '3D Design',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09075',
        courseName: 'Art History1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '08482',
        courseName: 'Digital Design1',
        category: 'career',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '09062',
        courseName: 'Art History2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '10944',
        courseName: 'Color&Design',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11708',
        courseName: 'Design Theory',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '08484',
        courseName: 'Digital Design2',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11724',
        courseName: 'Intro. to Design',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11415',
        courseName: '전공진로세미나1',
        category: 'career',
        grade: 1,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '01861',
        courseName: '도자공예1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11741',
        courseName: '디지털모델링1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10320',
        courseName: '문화예술교육개론',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 1,
      },
      {
        courseCode: '11309',
        courseName: '물레성형1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '03526',
        courseName: '섬유공예1',
        category: 'career',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '04308',
        courseName: '염색1',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10000',
        courseName: '전통공예표현기법',
        category: 'majorElective',
        grade: 2,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '10738',
        courseName: '공예교육론',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '01863',
        courseName: '도자공예2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11731',
        courseName: '디지털모델링2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11603',
        courseName: '로컬문화예술콘텐츠연구',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11310',
        courseName: '물레성형2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '03528',
        courseName: '섬유공예2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '04310',
        courseName: '염색2',
        category: 'majorElective',
        grade: 2,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11416',
        courseName: '전공진로세미나2',
        category: 'career',
        grade: 2,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '11728',
        courseName: 'Ceramic & Material Studies1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11739',
        courseName: 'Digital Fabrication1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11716',
        courseName: 'Fiber & Material Studies1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11604',
        courseName: '로컬아트스튜디오1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11734',
        courseName: '오브제1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11400',
        courseName: '위빙1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '06674',
        courseName: '텍스타일디자인1',
        category: 'majorElective',
        grade: 3,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11714',
        courseName: 'Ceramic & Material Studies2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11719',
        courseName: 'Digital Fabrication2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11717',
        courseName: 'Fiber & Material Studies2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11711',
        courseName: '공예교수학습방법',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11715',
        courseName: '오브제2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11401',
        courseName: '위빙2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11417',
        courseName: '전공진로세미나3',
        category: 'career',
        grade: 3,
        semester: 2,
        credits: 1,
        theoryHours: 0,
        practiceHours: 1,
      },
      {
        courseCode: '06676',
        courseName: '텍스타일디자인2',
        category: 'majorElective',
        grade: 3,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '11740',
        courseName: '공예프로그램개발',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 2,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11726',
        courseName: '문화상품개발및마케팅',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11394',
        courseName: '우븐스트럭쳐1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11424',
        courseName: '졸업작품연구1',
        category: 'career',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10576',
        courseName: '캡스톤디자인1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11737',
        courseName: '텍스타일상품기획및제작1',
        category: 'majorElective',
        grade: 4,
        semester: 1,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10331',
        courseName: '문화예술교육현장의이해와실습',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 2,
        theoryHours: 0,
        practiceHours: 2,
      },
      {
        courseCode: '11395',
        courseName: '우븐스트럭쳐2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11425',
        courseName: '졸업작품연구2',
        category: 'career',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '10577',
        courseName: '캡스톤디자인2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
      {
        courseCode: '11730',
        courseName: '텍스타일상품기획및제작2',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 2,
        practiceHours: 2,
      },
      {
        courseCode: '08557',
        courseName: '포트폴리오제작',
        category: 'majorElective',
        grade: 4,
        semester: 2,
        credits: 3,
        theoryHours: 1,
        practiceHours: 2,
      },
    ],
  },
  {
    collegeId: 'global_talent',
    collegeName: '글로벌인재대학',
    departmentId: 'global_liberal',
    departmentName: '글로벌자유전공학부',
    icon: '🌍',
    graduationCredits: 130,
    liberalArtsTotal: 69,
    liberalArtsBreakdown: {
      coreLiberal: 16,
      basicLiberal: 12,
      electiveLiberal: 28,
      characterEd: 0,
    },
    majorCredits: {
      careerSeminar: 0,
      majorBasicLiberal: 0,
      majorRequired: 0,
      majorElective: 0,
      majorTotal: 69,
      generalElective: 33,
    },
    courses: [
      {
        courseCode: '11784',
        courseName: 'AI 세미나',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09836',
        courseName: '기초한국어1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09834',
        courseName: '한국어회화1',
        category: 'majorElective',
        grade: 1,
        semester: 1,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '09837',
        courseName: '기초한국어2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
      {
        courseCode: '11785',
        courseName: '비즈니스영어',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 2,
        theoryHours: 2,
        practiceHours: 0,
      },
      {
        courseCode: '09835',
        courseName: '한국어회화2',
        category: 'majorElective',
        grade: 1,
        semester: 2,
        credits: 3,
        theoryHours: 3,
        practiceHours: 0,
      },
    ],
  },
];

// ── 헬퍼 함수 ────────────────────────────────────────────────────────────────

export function getDeptRequirements2026(departmentName) {
  return REQUIREMENTS_2026.find(r => r.departmentName === departmentName) ?? null;
}

export function getCreditRequirements2026(departmentName) {
  const dept = getDeptRequirements2026(departmentName);
  if (!dept) return null;
  return {
    graduationCredits: dept.graduationCredits,
    liberalArtsTotal: dept.liberalArtsTotal,
    majorRequired: dept.majorCredits.majorRequired,
    majorElective: dept.majorCredits.majorElective,
    majorTotal: dept.majorCredits.majorTotal,
  };
}

export function getCoursesBySemester2026(departmentName, grade, semester) {
  const dept = getDeptRequirements2026(departmentName);
  if (!dept) return [];
  return dept.courses.filter(c => c.grade === grade && c.semester === semester);
}

export function getRequiredCourses2026(departmentName) {
  const dept = getDeptRequirements2026(departmentName);
  if (!dept) return [];
  return dept.courses.filter(c => c.category === 'majorRequired' || c.category === 'majorCore');
}
